import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/axios";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

// Global translations
export const translations = {
  tr: {
    // Navigation
    dashboard: "Gösterge Paneli",
    feedback: "Geri Bildirim",
    roadmap: "Yol Haritası",
    changelog: "Değişiklik Günlüğü",
    widget: "Entegrasyon",
    users: "Kullanıcılar",
    contact: "İletişim",
    planManagement: "Plan Yönetimi",
    settings: "Ayarlar",
    upgrade: "Yükselt",
    language: "Dil",
    activeProject: "Aktif Proje",
    addProject: "Proje Ekle",
    addProjectMobile: "Ekle",
    logout: "Çıkış Yap",
    exitMobile: "Çıkış",
    purchaseNow: "Şimdi Satın Al",
    createNewProject: "Yeni Proje Oluştur",
    addNewProject: "Yeni proje ekleyerek feedback'lerinizi organize edin",
    projectName: "Proje Adı",
    projectNamePlaceholder: "Örn: Web Uygulamam",
    domain: "Domain (Opsiyonel)",
    domainPlaceholder: "example.com veya *.example.com",
    domainHint: "Domain'i daha sonra Widget ayarlarından ekleyebilir veya değiştirebilirsiniz",
    invalidDomainFormat: "Geçersiz domain formatı. Örnek: example.com veya *.example.com",
    createProject: "Proje Oluştur",
    // Login & Register
    welcomeBack: "Hoş Geldiniz",
    signInToContinue: "Devam etmek için hesabınıza giriş yapın",
    emailLabel: "E-posta",
    emailPlaceholder: "siz@sirket.com",
    passwordLabel: "Şifre",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Şifrenizi mi unuttunuz?",
    signIn: "Giriş Yap",
    signingIn: "Giriş yapılıyor...",
    dontHaveAccount: "Hesabınız yok mu?",
    signUp: "Kayıt Ol",
    createAccount: "Hesap Oluştur",
    getStarted: "Ücretsiz hesabınızla başlayın",
    companyName: "Şirket Adı",
    companyNamePlaceholder: "Acme A.Ş.",
    passwordRequirements: "Şifre Gereksinimleri",
    minLength: "En az 8 karakter",
    hasUpperCase: "En az bir büyük harf",
    hasLowerCase: "En az bir küçük harf",
    hasNumber: "En az bir rakam",
    hasSpecialChar: "En az bir özel karakter",
    acceptTermsAndPrivacy: "Kullanım Şartları ve Gizlilik Politikası'nı kabul ediyorum.",
    termsAndPrivacyRequired: "Kullanım Şartları ve Gizlilik Politikası'nı kabul etmelisiniz.",
    alreadyHaveAccount: "Zaten bir hesabınız var mı?",
    creatingAccount: "Hesap oluşturuluyor...",
    incorrectEmailOrPassword: "E-posta veya şifre hatalı",
    emailNotRegistered: "Bu e-posta adresi sistemde kayıtlı değil",
    incorrectPassword: "Şifre hatalı, lütfen tekrar deneyin",
    emailNotFound: "Bu e-posta adresiyle bir hesap bulunamadı",
    invalidEmailFormat: "Lütfen geçerli bir e-posta adresi girin",
    passwordRequirementsNotMet: "Lütfen şifre gereksinimlerini karşılayın",
    registrationFailed: "Kayıt işlemi başarısız oldu",
    registrationSuccessful: "Kayıt başarılı!",
    loginSuccess: "Giriş başarılı!",
    emailAlreadyRegistered: "Bu e-posta adresi zaten kayıtlı",
    backendConnectionError: "Backend sunucusuna bağlanılamıyor. Lütfen backend'in çalıştığından emin olun.",
    // Google OAuth
    orContinueWith: "Veya devam edin",
    googleSignIn: "Google ile Giriş Yap",
    googleSignUp: "Google ile Kayıt Ol",
    googleLoginError: "Google ile giriş başarısız. Lütfen tekrar deneyin.",
    signingInWithGoogle: "Google ile giriş yapılıyor...",
    // Email Verification
    verificationEmailSent: "Kayıt başarılı! Lütfen e-posta adresinizi onaylayın.",
    verifying: "Doğrulanıyor...",
    emailVerified: "E-mail Doğrulandı",
    emailNotVerified: "E-posta adresiniz doğrulanmamış. Lütfen e-postanızı kontrol edin ve hesabınızı doğrulayın.",
    emailVerificationRequired: "E-posta doğrulaması gerekli. Lütfen e-postanızı kontrol edin ve doğrulama bağlantısına tıklayın.",
    verificationError: "Doğrulama Hatası",
    verificationSuccess: "E-postanız başarıyla doğrulandı. Lütfen giriş yapın.",
    verificationInProgress: "Lütfen bekleyin...",
    redirectingToLogin: "Giriş sayfasına yönlendiriliyorsunuz...",
    verificationFailed: "Doğrulama başarısız oldu. Lütfen yeni bir hesap oluşturmayı deneyin veya destek ile iletişime geçin.",
    registerAgain: "Tekrar Kaydol",
    invalidOrExpiredToken: "Doğrulama token'ı geçersiz veya süresi dolmuş",
    // Password Reset
    resetPasswordTitle: "Şifre Sıfırla",
    resetPassword: "Şifre Sıfırla",
    resettingPassword: "Şifre Sıfırlanıyor...",
    newPassword: "Yeni Şifre",
    confirmPassword: "Şifreyi Onayla",
    passwordResetSuccess: "Şifreniz başarıyla sıfırlandı. Lütfen giriş yapın.",
    passwordResetError: "Şifre Sıfırlama Hatası",
    passwordResetFailed: "Şifre sıfırlama başarısız oldu.",
    requestNewLink: "Yeni Bağlantı İste",
    enterNewPassword: "Yeni şifrenizi girin",
    // Forgot Password
    forgotPasswordTitle: "Şifremi Unuttum",
    forgotPasswordDescription: "E-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim",
    checkYourEmail: "E-postanızı kontrol edin",
    passwordResetLinkSent: "Şifre sıfırlama bağlantısı e-postanıza gönderildi!",
    passwordResetLinkSentTo: "Şifre sıfırlama bağlantısı şu adrese gönderildi",
    checkEmailInbox: "Lütfen e-posta kutunuzu kontrol edin. E-postayı görmüyorsanız, spam klasörünüze bakın.",
    sendNewEmail: "Yeni E-posta Gönder",
    sending: "Gönderiliyor...",
    sendPasswordResetLink: "Şifre Sıfırlama Bağlantısı Gönder",
    backToSignIn: "Giriş Sayfasına Dön",
    errorOccurred: "Bir hata oluştu. Lütfen tekrar deneyin.",
    // Contact
    contactTitle: "İletişim",
    contactDescription: "Bizimle iletişime geçin",
    sendMessage: "Mesaj Gönder",
    contactDescriptionText: "Sorularınız veya önerileriniz için bize ulaşın",
    contactModalTitle: "Kurumsal plan hakkında iletişime geçin",
    contactModalDescription: "Talebinizi iletin, en kısa sürede size dönüş yapalım. Landing sayfasındaki iletişim formu ile aynı SMTP ayarları kullanılır.",
    yourName: "Adınız",
    email: "E-posta",
    subject: "Konu",
    message: "Mesajınız",
    messagePlaceholder: "Mesajınızı buraya yazın...",
    subjectPlaceholder: "Mesaj konusu",
    sending: "Gönderiliyor...",
    messageSent: "Mesajınız başarıyla gönderildi!",
    messageFailed: "Mesaj gönderilemedi. Lütfen tekrar deneyin.",
    allFieldsRequired: "Lütfen tüm alanları doldurun",
    pleaseFillThisField: "Lütfen bu alanı doldurun",
    projectCreated: "Proje başarıyla oluşturuldu!",
    projectCreateFailed: "Proje oluşturulamadı",
    // Team/Users
    usersTitle: "Kullanıcılar",
    usersDescription: "projesine feedback bırakan kullanıcılar",
    usersDescriptionNoProject: "Projeye feedback bırakan kullanıcılar",
    noUsersYet: "Henüz kullanıcı yok",
    noUsersDescription:
      "Projeye feedback bırakan kullanıcılar burada görünecek",
    anonymous: "Anonim",
    feedbacks: "Feedback",
    lastActivity: "Son Aktivite",
    userActivityHistory: "Kullanıcının aktivite geçmişi",
    submittedFeedbacks: "Attığı Feedbackler",
    noFeedbacksYet: "Bu kullanıcı henüz feedback göndermemiş",
    loading: "Yükleniyor...",
    type: "Tip",
    status: "Durum",
    // Widget
    widgetIntegration: "Widget Entegrasyonu",
    widgetDescription:
      "Web sitenize feedback widget'ını ekleyin ve özelleştirin",
    customize: "Özelleştirme",
    integrationCode: "Entegrasyon Kodu",
    widgetSettings: "Widget Ayarları",
    widgetSettingsDescription: "Widget görünümünü ve davranışını özelleştirin",
    buttonColor: "Buton Rengi",
    backgroundColor: "Arka Plan Rengi",
    buttonStyle: "Buton Stili",
    rounded: "Yuvarlak",
    roundedLarge: "Köşeleri Yuvarlatılmış",
    roundedSmall: "Hafif Yuvarlatılmış",
    roundedNone: "Köşeli",
    fontFamily: "Yazı Tipi",
    fontSize: "Yazı Boyutu",
    small: "Küçük",
    medium: "Orta",
    large: "Büyük",
    veryLarge: "Çok Büyük",
    theme: "Tema",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    buttonPosition: "Button Konumu (Opsiyonel)",
    buttonPositionPlaceholder: "#blog-footer veya .feedback-section",
    buttonPositionDescription:
      "Boş bırakılırsa sayfanın alt ortasında görünür. CSS selector girin (örn: #container-id veya .class-name)",
    save: "Kayıt Et",
    livePreview: "Canlı Önizleme",
    livePreviewDescription: "Widget'ın web sitenizde nasıl görüneceğini görün",
    websiteContent: "Web sitenizin içeriği burada görünecek",
    feedback: "Geri Bildirim",
    featureRequest: "Özellik İsteği",
    bug: "Hata",
    other: "Diğer",
    roadmap: "Yol Haritası",
    changelog: "Değişiklik Günlüğü",
    title: "Title",
    titlePlaceholder: "Brief description of your feedback",
    description: "Description",
    descriptionPlaceholder: "Provide more details about your feedback...",
    yourName: "Your Name",
    yourNamePlaceholder: "John Doe",
    yourEmail: "Your Email",
    yourEmailPlaceholder: "john@example.com",
    submitFeedback: "Submit Feedback",
    feedbackSubmitted: "Feedback gönderildi! (Preview modu)",
    activeProjectNotFound:
      "Aktif proje bulunamadı. Lütfen önce bir proje seçin.",
    selectFramework: "Framework / Platform Seçin",
    reactCode: "React Component Kodu",
    vueCode: "Vue Component Kodu",
    nuxtCode: "Nuxt Plugin Kodu",
    nextCode: "Next.js Component Kodu",
    wordpressCode: "WordPress PHP Kodu",
    generalGuide: "Genel Entegrasyon Rehberi",
    copyCode: "Kodu Kopyala",
    copyContent: "İçeriği Kopyala",
    copied: "Kopyalandı!",
    installationInstructions: "Kurulum Talimatları",
    changesSaved: "Değişiklikler Kaydedildi",
    changesSavedDescription:
      "Widget ayarlarınız başarıyla kaydedildi. Entegrasyon kodunu almak için aşağıdaki butona tıklayın.",
    close: "Kapat",
    getIntegrationCode: "Entegrasyon Kodunu Al",
    widgetUsage: "Kullanım:",
    widgetUsageVue: "Kullanım (App.vue veya parent component'te):",
    widgetUsageNext: "Kullanım (app.tsx veya page.tsx):",
    widgetNuxtPluginComment1: "// plugins/feedback-widget.client.js",
    widgetNuxtPluginComment2: "// Bu plugin otomatik olarak tüm sayfaları initalize eder",
    widgetNuxtPluginComment3: "// tenantId: {tenantId} ile yapılandırılmıştır",
    widgetWpUrlComment: "// Widget URL - her zaman feedpanels.com'dan yüklenir",
    widgetOtherScriptComment: "<!-- Widget script'ini yükle -->",
    // Installation instructions by framework
    reactInstall1: "Yukarıdaki component kodunu kopyalayın",
    reactInstall2:
      "Component'i projenizde uygun bir yere ekleyin (örn: App.js veya Layout component)",
    reactInstall3: "Component'i import edip render edin:",
    reactInstall4: "Değişiklikleri kaydedin ve uygulamanızı yenileyin",
    reactInstall5:
      "Component render edildiğinde widget butonunun göründüğünü kontrol edin",
    vueInstall1: "Yukarıdaki component kodunu kopyalayın",
    vueInstall2: "Component'i projenizde components klasörüne ekleyin",
    vueInstall3:
      "Component'i kullanmak istediğiniz sayfada import edin ve kullanın",
    vueInstall4: "Değişiklikleri kaydedin ve uygulamanızı yenileyin",
    vueInstall5:
      "Component mount edildiğinde widget butonunun göründüğünü kontrol edin",
    nuxtInstall1: "Yukarıdaki plugin kodunu kopyalayın",
    nuxtInstall2: "Kodu",
    nuxtInstall3: "dosyasına kaydedin",
    nuxtInstall4: "Nuxt otomatik olarak plugin'i yükleyecektir",
    nuxtInstall5: "Uygulamanızı yeniden başlatın",
    nuxtInstall6:
      "Sayfa yüklendiğinde widget butonunun göründüğünü kontrol edin",
    nextInstall1: "Yukarıdaki component kodunu kopyalayın",
    nextInstall2: "Component'i",
    nextInstall3: "dosyasına kaydedin",
    nextInstall4: "Component'i layout veya sayfa dosyanıza import edin:",
    nextInstall5: "Değişiklikleri kaydedin ve uygulamanızı yenileyin",
    nextInstall6:
      "Sayfa render edildiğinde widget butonunun göründüğünü kontrol edin",
    wordpressInstall1: "Yukarıdaki PHP kodunu kopyalayın",
    wordpressInstall2: "WordPress admin paneline giriş yapın",
    wordpressInstall3:
      "Görünüm → Tema Düzenleyici → functions.php dosyasını açın",
    wordpressInstall4: "Kodu functions.php dosyasının sonuna ekleyin",
    wordpressInstall5: "Dosyayı kaydedin",
    wordpressInstall6:
      "Sayfayı yenilediğinizde widget butonunun göründüğünü kontrol edin",
    wordpressCodeComment: "WordPress: functions.php dosyanıza ekleyin",
    // Other framework guide
    otherUsage: "Herhangi bir web sitesinde kullanım",
    otherInstallation: "Kurulum",
    otherInstallationDescription:
      "Tüm FeedbackFlow yerleştirme özelliklerini etkinleştirmek için bu tek betik etiketini ekleyin:",
    otherFeature1: "Özellik 1: Geri Bildirim Aracı",
    otherFeature1Description: "Kullanıcılarınızdan geri bildirim toplayın.",
    otherFeature1Details:
      'Widget otomatik olarak sayfanın alt ortasında bir "Feature Request" butonu görüntüler. Buton tıklandığında geri bildirim modal\'ı açılır ve kullanıcılar:',
    otherFeature1Item1: "- Feature Request (Özellik İsteği)",
    otherFeature1Item2: "- Bug (Hata Bildirimi)",
    otherFeature1Item3: "- Other (Diğer)",
    otherFeature1Item4: "geri bildirim türlerinden birini seçebilir.",
    otherFeature2: "Özellik 2: Yol Haritası Widget'ı",
    otherFeature2Description:
      'Yol haritanızı görüntülemek için modal içindeki "Yol Haritası" butonunu kullanın. Bu buton yeni bir sekmede public roadmap sayfanızı açar.',
    otherFeature3: "Özellik 3: Changelog Widget'ı",
    otherFeature3Description:
      'Son güncellemeleri görüntülemek için modal içindeki "Changelog" butonunu kullanın. Bu buton yeni bir sekmede public changelog sayfanızı açar.',
    otherCustomization: "Özelleştirme",
    otherCustomizationDescription:
      "Widget görünümünü özelleştirmek için init fonksiyonundaki parametreleri değiştirebilirsiniz:",
    otherParam1: "- tenantId: Projenizin benzersiz kimliği",
    otherParam2: '- primaryColor: Buton rengi (hex formatında, örn: "#0891b2")',
    otherParam3:
      '- backgroundColor: Modal arka plan rengi (hex formatında, örn: "#ffffff")',
    otherParam4:
      '- buttonStyle: Buton stili ("rounded-full", "rounded-lg", "rounded", "rounded-none")',
    otherParam5: '- fontSize: Yazı boyutu (örn: "16px")',
    otherParam6: '- fontFamily: Yazı tipi (örn: "Inter, sans-serif")',
    otherParam7: '- theme: Tema ("light" veya "dark")',
    otherExample: "Örnek Kullanım",
    otherExampleBasic: "Temel kurulum:",
    otherNote:
      "Not: Widget'ı web sitenizin </body> etiketinden hemen önce ekleyin. Widget otomatik olarak yüklenecek ve sayfanın alt ortasında görünecektir.",
    // Changelog
    changelogTitle: "Değişiklik Günlüğü",
    changelogDescription:
      "Kullanıcılarınızı güncellemeler hakkında bilgilendirin",
    viewPublicChangelog: "Halka Açık Changelog'u Görüntüle",
    newRelease: "Yeni Sürüm",
    createChangelogEntry: "Changelog Girişi Oluştur",
    createChangelogDescription: "Son sürümünüzü veya güncellemenizi belgeleyin",
    version: "Versiyon",
    versionPlaceholder: "v2.1.0",
    title: "Başlık",
    titlePlaceholder: "Slack Entegrasyonu & Performans İyileştirmeleri",
    content: "İçerik",
    contentPlaceholder:
      "Yeni Özellikler:\n- Slack entegrasyonu\n- Dark mode\n\nHata Düzeltmeleri:\n- E-posta bildirimleri düzeltildi",
    publishChangelog: "Changelog Yayınla",
    loadingChangelog: "Changelog yükleniyor...",
    noChangelogEntries: "Henüz changelog girişi yok",
    createFirstReleaseNote: "İlk sürüm notunuzu oluşturun",
    deleteChangelogEntry: "Changelog Girişini Sil",
    deleteChangelogConfirm:
      "Bu changelog girişini silmek istediğinizden emin misiniz?",
    deleteChangelogWarning:
      "Bu işlem geri alınamaz ve changelog hem admin panelinden hem de halka açık portaldan kaldırılacaktır.",
    cancel: "İptal",
    delete: "Sil",
    changelogCreated: "Changelog oluşturuldu",
    changelogCreateFailed: "Changelog oluşturulamadı",
    changelogDeleted: "Changelog başarıyla silindi",
    changelogDeleteFailed: "Changelog silinemedi",
    changelogLoadFailed: "Changelog yüklenemedi",
    pleaseSelectProject: "Lütfen önce bir proje seçin",
    // Roadmap
    productRoadmap: "Ürün Yol Haritası",
    roadmapDescription: "Ürün özelliklerinizi planlayın ve takip edin",
    newItem: "Yeni Öğe",
    createRoadmapItem: "Yol Haritası Öğesi Oluştur",
    createRoadmapDescription:
      "Yol haritanıza yeni bir özellik veya girişim ekleyin",
    roadmapTitle: "Başlık",
    roadmapTitlePlaceholder: "Slack Entegrasyonu",
    roadmapDescriptionLabel: "Açıklama",
    roadmapDescriptionPlaceholder: "Bildirimler için Slack ile entegre olun...",
    quarter: "Çeyrek",
    quarterPlaceholder: "Q2 2025",
    status: "Durum",
    createItem: "Öğe Oluştur",
    loadingRoadmap: "Yol haritası yükleniyor...",
    noRoadmapItems: "Henüz yol haritası öğesi yok",
    items: "öğe",
    fromFeedback: "Feedback'ten",
    votes: "oy",
    statusUpdated: "Durum başarıyla güncellendi",
    statusUpdateFailed: "Durum güncellenemedi",
    roadmapItemCreated: "Yol haritası öğesi oluşturuldu",
    roadmapItemCreateFailed: "Öğe oluşturulamadı",
    roadmapLoadFailed: "Yol haritası yüklenemedi",
    roadmapItemDeleted: "Yol haritası öğesi silindi. Public panelden de kaldırıldı.",
    roadmapItemDeleteFailed: "Yol haritası öğesi silinemedi",
    deleteRoadmapItem: "Yol haritası öğesini sil",
    deleteRoadmapItemConfirm: "Bu öğeyi silmek istediğinize emin misiniz? Public yol haritasından da kaldırılacaktır.",
    roadmapItemFromFeedbackCannotDelete: "Bu öğe bir geri bildirimden geliyor. Sadece Geri Bildirim panelinden silebilirsiniz.",
    // Roadmap Status Labels
    backlog: "Beklemede",
    planned: "Planlandı",
    inDevelopment: "Geliştiriliyor",
    testing: "Test Ediliyor",
    completed: "Tamamlandı",
    // Feedback
    feedbackTitle: "Geri Bildirim",
    feedbackDescription: "Müşteri geri bildirimlerini ve isteklerini yönetin",
    loadingFeedback: "Geri bildirim yükleniyor...",
    noFeedbackYet: "Henüz geri bildirim yok",
    noFeedbackDescription:
      "Kullanıcılar public portal üzerinden geri bildirim gönderebilir",
    loading: "Yükleniyor...",
    submittedBy: "Gönderen",
    anonymous: "Anonim",
    description: "Açıklama",
    updateStatus: "Durumu Güncelle",
    upvotes: "Beğeni",
    views: "Görüntüleme",
    deleteFeedback: "Feedback Sil",
    deleteFeedbackConfirm: "Bu feedback'i silmek istediğinizden emin misiniz?",
    deleteFeedbackWarning:
      "Bu işlem geri alınamaz. Feedback şu yerlerden kaldırılacak:",
    adminPanel: "Admin paneli",
    publicPortal: "Halka açık portal",
    roadmap: "Yol haritası",
    allRelatedVotes: "Tüm ilgili oylar",
    cancel: "İptal",
    delete: "Sil",
    feedbackDeleted: "Feedback başarıyla silindi",
    feedbackDeleteFailed: "Feedback silinemedi",
    feedbackLoadFailed: "Feedback yüklenemedi",
    voteFailed: "Oylama başarısız",
    statusUpdated: "Durum güncellendi",
    statusUpdateFailed: "Durum güncellenemedi",
    // Feedback Type Labels
    feature: "Feature",
    bug: "Bug",
    improvement: "İyileştirme",
    other: "Diğer",
    // Priority Labels
    low: "Düşük",
    medium: "Orta",
    high: "Yüksek",
    urgent: "Acil",
    // Comments
    comments: "Yorumlar",
    comment: "Yorum",
    writeComment: "Yorumunuzu yazın...",
    submitComment: "Yorum Gönder",
    commentSubmitted: "Yorum gönderildi",
    commentSubmitFailed: "Yorum gönderilemedi",
    commentRequired: "Yorum boş olamaz",
    commentsLoadFailed: "Yorumlar yüklenemedi",
    failedToLoadComments: "Yorumlar yüklenemedi",
    failedToSubmitComment: "Yorum gönderilemedi",
    noCommentsYet: "Henüz yorum yok. İlk yorumu siz yapın!",
    reply: "Cevap Ver",
    writeReply: "Cevabınızı yazın...",
    sendReply: "Cevap Gönder",
    replySubmitted: "Cevap gönderildi",
    replySubmitFailed: "Cevap gönderilemedi",
    cancelReply: "İptal",
    internal: "İç",
    public: "Public",
    projectSettings: "Proje Ayarları",
    enableComments: "Yorumları Etkinleştir",
    enableCommentsDescription:
      "Kullanıcıların feedback'lere yorum yapmasına izin ver",
    commentsEnabled: "Yorumlar açıldı",
    commentsDisabled: "Yorumlar kapatıldı",
    settingsUpdateFailed: "Ayarlar güncellenemedi",
    unsavedChangesTitle: "Kaydedilmemiş Değişiklikler",
    unsavedChangesMessage:
      "Özelleştirme ayarlarınızda kaydedilmemiş değişiklikler var. Entegrasyon koduna geçerseniz bu değişiklikler kaybolacak ve kod mevcut ayarlardan farklı olacaktır.",
    continueAnyway: "Yine de Devam Et",
    // Dashboard
    welcomeBack: "Tekrar hoş geldiniz! 👋",
    dashboardIntro: "Geri bildirimlerinizle ilgili özet bilgiler",
    totalFeedback: "Toplam Geri Bildirim",
    allTime: "Tüm zamanlar",
    activeFeedback: "Aktif Geri Bildirim",
    inProgress: "Devam eden",
    thisMonth: "Bu Ay",
    newSubmissions: "Yeni gönderimler",
    topFeedback: "En Çok Beğenilen",
    noFeedbackYet: "Henüz geri bildirim yok",
    yourProjects: "Projeleriniz",
    active: "Aktif",
    created: "Oluşturulma",
    quickActions: "Hızlı İşlemler",
    viewAllFeedback: "Tüm Geri Bildirimleri Görüntüle",
    manageRoadmap: "Roadmap Yönet",
    setupWidget: "Widget Kurulumu",
    publicPages: "Halka Açık Sayfalar",
    publicFeedback: "Halka Açık Geri Bildirim",
    publicRoadmap: "Halka Açık Roadmap",
    publicChangelog: "Halka Açık Changelog",
    selectProjectToViewPublicPages:
      "Halka açık sayfaları görüntülemek için bir proje seçin",
    ipAddress: "IP Adresi",
    daysRemaining: "Kalan Gün",
    status: "Durum",
    statsLoadFailed: "İstatistikler yüklenemedi",
    welcomeToFeedbackFlow: "FeedbackFlow'a Hoş Geldiniz! 🎉",
    firstProjectModalDescription:
      "Başlamak için ilk projenizi oluşturun. Proje adı, geri bildirimlerinizi organize etmenize yardımcı olur.",
    moreProjectsHint: "💡 İstediğiniz zaman daha fazla proje ekleyebilirsiniz",
    createProject: "Projeyi Oluştur",
    creatingProject: "Oluşturuluyor...",
    projectNamePlaceholder: "Örn: Web Uygulamam",
    pleaseEnterProjectName: "Lütfen proje adı girin",
    projectCreatedWelcome: "Proje oluşturuldu! FeedbackFlow'a hoş geldiniz!",
    howToIntegrateButton: "Entegrasyon nasıl yapılır?",
    integrationGuideTitle: "Entegrasyon Rehberi",
    integrationPreStep: "Başlamadan Önce",
    integrationPreStepDesc: "Başlamadan önce, lütfen projenizi oluşturun ve oluşturduğunuz projeye bir domain adı vermeyi unutmayın. Eğer projeniz ve domain adınız zaten oluşturulmuş ise, aktif proje olarak hangi projeyi entegre etmek istiyorsanız, onun seçili olduğundan emin olun.",
    integrationStep1: "Dashboard menüsünden 'Entegrasyon' sekmesine gidin",
    integrationStep1Desc: "Sol menüden 'Entegrasyon' veya 'Widget' sekmesine tıklayarak entegrasyon sayfasına ulaşabilirsiniz. Bu sayfada widget'ınızı özelleştirip entegrasyon kodunu alabilirsiniz.",
    integrationStep2: "Widget ayarlarınızı özelleştirin (renk, konum, stil vb.)",
    integrationStep2Desc: "Widget'ınızın görünümünü markanıza uygun hale getirin. Renk, buton stili, yazı tipi ve boyutu gibi ayarları değiştirebilirsiniz. Yaptığınız değişiklikleri 'Kaydet' butonuna tıklayarak kaydedin.",
    integrationStep3: "Framework'ünüze uygun entegrasyon kodunu kopyalayın",
    integrationStep3Desc: "'Entegrasyon Kodu' sekmesine geçin ve kullandığınız framework'ü seçin (React, Vue, Next.js, WordPress vb.). Seçtiğiniz framework için hazırlanmış kodu kopyalayın.",
    integrationStep4: "Kodu web sitenizin uygun yerine ekleyin",
    integrationStep4Desc: "Kopyaladığınız kodu web sitenizin uygun yerine yapıştırın. Genellikle ana layout dosyanız veya root component'inizde widget bileşenini eklemeniz yeterlidir. Kod, widget'ı otomatik olarak yükleyecektir.",
    integrationStep5: "Widget'ınız artık kullanıma hazır!",
    integrationStep5Desc: "Kodu ekledikten sonra web sitenizi yenileyin. Widget butonu sayfanızın alt kısmında görünecektir. Kullanıcılar bu butona tıklayarak geri bildirim gönderebilirler.\n\nNot: Entegrasyon kodunuzda Tenant ID otomatik olarak yerleştirilmiştir. Bu ID, hangi projeye geri bildirim gönderileceğini belirler. Tenant ID'nizi Widget entegrasyon kodundan görebilirsiniz.",
    previous: "Önceki",
    next: "Sonraki",
    purchaseLicense: "Lisans Al",
    // Public Portal
    publicPortal: "Halka Açık Portal",
    feedbackNav: "Geri Bildirim",
    roadmapNav: "Yol Haritası",
    changelogNav: "Değişiklik Günlüğü",
    feedbackTitle: "💬 Geri Bildirim",
    feedbackDescription: "Geri bildirimlerinizi ve fikirlerinizi paylaşın",
    submitFeedback: "Geri Bildirim Gönder",
    submitYourFeedback: "Geri Bildiriminizi Gönderin",
    helpUsImprove:
      "Fikirlerinizi ve önerilerinizi paylaşarak bize yardımcı olun",
    feedbackType: "Geri Bildirim Türü",
    featureRequest: "Özellik İsteği",
    bugReport: "Hata Raporu",
    improvement: "İyileştirme",
    other: "Diğer",
    title: "Başlık",
    briefDescription: "Geri bildiriminizin kısa açıklaması",
    description: "Açıklama",
    provideMoreDetails: "Geri bildiriminiz hakkında daha fazla detay verin...",
    yourName: "Adınız",
    yourEmail: "E-postanız",
    feedbackSubmittedSuccess:
      "Geri bildirim başarıyla gönderildi! İnceleme sonrası görünür olacak.",
    projectNotFound: "Proje bulunamadı",
    projectNotFoundDescription: "Aradığınız proje mevcut değil",
    projectNotFoundText:
      "Erişmeye çalıştığınız proje mevcut değil veya henüz kurulmamış.",
    contactAdministrator:
      "Lütfen yöneticiyle iletişime geçin, ardından halka açık sayfaya tekrar erişmeyi deneyin.",
    all: "Tümü",
    backlog: "Beklemede",
    planned: "Planlandı",
    inDevelopment: "Geliştiriliyor",
    testing: "Test Ediliyor",
    completed: "Tamamlandı",
    new: "Yeni",
    underReview: "İncelemede",
    inProgress: "Devam Ediyor",
    mostVoted: "En Çok Oylanan",
    newestFirst: "En Yeni",
    oldestFirst: "En Eski",
    noFeedbackYet: "Henüz geri bildirim yok",
    beFirstToShare: "İlk düşüncelerinizi paylaşan siz olun!",
    views: "görüntüleme",
    by: "tarafından",
    voteSaved: "Beğeniniz kaydedildi!",
    voteRemoved: "Beğeni geri alındı",
    failedToVote: "Oy verme başarısız oldu. Lütfen tekrar deneyin.",
    failedToLoadFeedback: "Geri bildirim yüklenemedi",
    loading: "Yükleniyor...",
    productRoadmap: "Ürün Yol Haritası",
    seeWhatWeWorkingOn: "Ne üzerinde çalıştığımızı ve sırada ne olduğunu görün",
    noRoadmapItemsYet: "Henüz yol haritası öğesi yok",
    items: "öğe",
    loadingRoadmap: "Yol haritası yükleniyor...",
    failedToLoadRoadmap: "Yol haritası yüklenemedi",
    changelog: "Değişiklik Günlüğü",
    stayUpdated: "En son sürümlerimiz ve iyileştirmelerimizle güncel kalın",
    noReleasesYet: "Henüz sürüm yok",
    checkBackSoon: "Güncellemeler için yakında tekrar kontrol edin",
    loadingChangelog: "Değişiklik günlüğü yükleniyor...",
    failedToLoadChangelog: "Değişiklik günlüğü yüklenemedi",
    boardNotFound: "Pano bulunamadı",
    boardNotFoundDescription: "Aradığınız pano mevcut değil",
    boardNotFoundText:
      "Erişmeye çalıştığınız pano mevcut değil veya henüz kurulmamış.",
    contactAdminToSetup:
      "Lütfen yöneticiyle iletişime geçerek bir pano kurun, ardından halka açık sayfaya tekrar erişmeyi deneyin.",
    selectCategory: "Bir kategori seçin",
    category: "Kategori",
    poweredBy: "Destekleyen",
    footerCopyright: `© ${new Date().getFullYear()} ZeuZ IT tarafından oluşturuldu`,
    privacyPolicy: "Gizlilik Politikası",
    legalNotice: "Yasal Uyarı",
    // Inactive Project Modal
    inactiveProjectTitle: "⚠️ Aktif Olmayan Proje",
    inactiveProjectMessage: "Bu proje aktif değildir. Bu proje için entegrasyonları kullanamaz ve widget'ı başlatamaz.",
    inactiveProjectExplanation: "Bu projeyi aktif hale getirmek için Plan Yönetimi → Aktif Projeler sekmesine gidin ve projeyi etkinleştirin.",
    activate: "Aç ve Etkinleştir",
    activatingProject: "Etkinleştiriliyor...",
    goToPlanManagement: "Tümünü Yönet",
    cancel: "İptal",
    maxActiveProjectsReached: "En fazla aktif proje sayısına ulaştınız",
    activationFailed: "Etkinleştirme başarısız oldu",
    projectActivated: "Proje başarıyla etkinleştirildi",
    projectDeactivated: "Proje başarıyla devre dışı bırakıldı",
    pendingDowngradeTitle: "Plan Değişikliği Zaten Bekleniyör",
    pendingDowngradeMessage: "{plan} paketine geçiş işleminiz {date} tarihinde gerçekleşecektir. Lütfen işlemin tamamlanmasını bekleyin.",
    ok: "Tamam",
  },
  en: {
    dashboard: "Dashboard",
    feedback: "Feedback",
    roadmap: "Roadmap",
    changelog: "Changelog",
    widget: "Integrations",
    users: "Users",
    contact: "Contact",
    planManagement: "Plan Management",
    settings: "Settings",
    upgrade: "Upgrade",
    language: "Language",
    activeProject: "Active Project",
    addProject: "Add Project",
    addProjectMobile: "Add",
    logout: "Logout",
    exitMobile: "Exit",
    purchaseNow: "Purchase now",
    createNewProject: "Create New Project",
    addNewProject: "Add a new project to organize your feedback",
    projectName: "Project Name",
    projectNamePlaceholder: "Ex: My Web App",
    domain: "Domain (Optional)",
    domainPlaceholder: "example.com or *.example.com",
    domainHint: "You can add or change domains later in Widget settings",
    invalidDomainFormat: "Invalid domain format. Example: example.com or *.example.com",
    createProject: "Create Project",
    // Login & Register
    welcomeBack: "Welcome back",
    signInToContinue: "Sign in to your account to continue",
    emailLabel: "Email",
    emailPlaceholder: "you@company.com",
    passwordLabel: "Password",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Forgot Password?",
    signIn: "Sign In",
    signingIn: "Signing in...",
    dontHaveAccount: "Don't have an account?",
    signUp: "Sign up",
    createAccount: "Create account",
    getStarted: "Get started with your free account",
    companyName: "Company Name",
    companyNamePlaceholder: "Acme Inc.",
    passwordRequirements: "Password Requirements",
    minLength: "At least 8 characters",
    hasUpperCase: "At least one uppercase letter",
    hasLowerCase: "At least one lowercase letter",
    hasNumber: "At least one number",
    hasSpecialChar: "At least one special character",
    acceptTermsAndPrivacy: "I accept the Terms of Service and Privacy Policy.",
    termsAndPrivacyRequired: "You must accept the Terms of Service and Privacy Policy.",
    alreadyHaveAccount: "Already have an account?",
    creatingAccount: "Creating account...",
    incorrectEmailOrPassword: "Incorrect email or password",
    emailNotRegistered: "This email address is not registered in the system",
    incorrectPassword: "Password is incorrect, please try again",
    emailNotFound: "No account found with this email address",
    invalidEmailFormat: "Please enter a valid email address",
    passwordRequirementsNotMet: "Please meet the password requirements",
    registrationFailed: "Registration failed",
    registrationSuccessful: "Registration successful!",
    loginSuccess: "Login successful!",
    emailAlreadyRegistered: "This email address is already registered",
    backendConnectionError: "Cannot connect to backend server. Please make sure the backend is running.",
    // Google OAuth
    orContinueWith: "Or continue with",
    googleSignIn: "Sign in with Google",
    googleSignUp: "Sign up with Google",
    googleLoginError: "Google login failed. Please try again.",
    signingInWithGoogle: "Signing in with Google...",
    // Email Verification
    verificationEmailSent: "Registration successful! Please verify your email address.",
    verifying: "Verifying...",
    emailVerified: "Email Verified",
    emailNotVerified: "Your email address is not verified. Please check your email and verify your account.",
    emailVerificationRequired: "Email verification required. Please check your email and click the verification link.",
    verificationError: "Verification Error",
    verificationSuccess: "Your email has been verified successfully. Please login.",
    verificationInProgress: "Please wait...",
    redirectingToLogin: "You will be redirected to the login page...",
    verificationFailed: "Verification failed. Please try creating a new account or contact support.",
    registerAgain: "Register Again",
    invalidOrExpiredToken: "Verification token is invalid or expired",
    // Password Reset
    resetPasswordTitle: "Reset Password",
    resetPassword: "Reset Password",
    resettingPassword: "Resetting password...",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    passwordResetSuccess: "Your password has been reset successfully. Please login.",
    passwordResetError: "Password Reset Error",
    passwordResetFailed: "Password reset failed.",
    requestNewLink: "Request New Link",
    enterNewPassword: "Enter your new password",
    // Forgot Password
    forgotPasswordTitle: "Forgot Password",
    forgotPasswordDescription: "Enter your email address and we'll send you a password reset link",
    checkYourEmail: "Check your email",
    passwordResetLinkSent: "Password reset link has been sent to your email!",
    passwordResetLinkSentTo: "Password reset link has been sent to",
    checkEmailInbox: "Please check your email inbox. If you don't see the email, check your spam folder.",
    sendNewEmail: "Send New Email",
    sending: "Sending...",
    sendPasswordResetLink: "Send Password Reset Link",
    backToSignIn: "Back to Sign In",
    errorOccurred: "An error occurred. Please try again.",
    contactTitle: "Contact",
    contactDescription: "Get in touch with us",
    sendMessage: "Send Message",
    contactDescriptionText: "Reach out to us for your questions or suggestions",
    contactModalTitle: "Contact us about the Enterprise plan",
    contactModalDescription: "Send your request and we will get back to you as soon as possible. The same SMTP settings as the landing page contact form are used.",
    yourName: "Your Name",
    email: "Email",
    subject: "Subject",
    message: "Your Message",
    messagePlaceholder: "Write your message here...",
    subjectPlaceholder: "Message subject",
    sending: "Sending...",
    messageSent: "Your message has been sent successfully!",
    messageFailed: "Failed to send message. Please try again.",
    allFieldsRequired: "Please fill in all fields",
    pleaseFillThisField: "Please fill in this field",
    projectCreated: "Project created successfully!",
    projectCreateFailed: "Failed to create project",
    // Team/Users
    usersTitle: "Users",
    usersDescription: "project users who have submitted feedback",
    usersDescriptionNoProject:
      "Users who have submitted feedback to the project",
    noUsersYet: "No users yet",
    noUsersDescription:
      "Users who submit feedback to the project will appear here",
    anonymous: "Anonymous",
    feedbacks: "Feedbacks",
    lastActivity: "Last Activity",
    userActivityHistory: "User activity history",
    submittedFeedbacks: "Submitted Feedbacks",
    noFeedbacksYet: "This user has not submitted any feedback yet",
    loading: "Loading...",
    type: "Type",
    status: "Status",
    // Widget
    widgetIntegration: "Widget Integration",
    widgetDescription: "Add and customize the feedback widget to your website",
    customize: "Customize",
    integrationCode: "Integration Code",
    widgetSettings: "Widget Settings",
    widgetSettingsDescription: "Customize widget appearance and behavior",
    buttonColor: "Button Color",
    backgroundColor: "Background Color",
    buttonStyle: "Button Style",
    rounded: "Round",
    roundedLarge: "Rounded Corners",
    roundedSmall: "Slightly Rounded",
    roundedNone: "Square",
    fontFamily: "Font Family",
    fontSize: "Font Size",
    small: "Small",
    medium: "Medium",
    large: "Large",
    veryLarge: "Very Large",
    theme: "Theme",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    buttonPosition: "Button Position (Optional)",
    buttonPositionPlaceholder: "#blog-footer or .feedback-section",
    buttonPositionDescription:
      "If left empty, appears at the bottom center of the page. Enter a CSS selector (e.g., #container-id or .class-name)",
    save: "Save",
    livePreview: "Live Preview",
    livePreviewDescription: "See how the widget will appear on your website",
    websiteContent: "Your website content will appear here",
    feedback: "Feedback",
    featureRequest: "Feature Request",
    bug: "Bug",
    other: "Other",
    roadmap: "Roadmap",
    changelog: "Changelog",
    title: "Title",
    titlePlaceholder: "Brief description of your feedback",
    description: "Description",
    descriptionPlaceholder: "Provide more details about your feedback...",
    yourName: "Your Name",
    yourNamePlaceholder: "John Doe",
    yourEmail: "Your Email",
    yourEmailPlaceholder: "john@example.com",
    submitFeedback: "Submit Feedback",
    feedbackSubmitted: "Feedback submitted! (Preview mode)",
    activeProjectNotFound:
      "Active project not found. Please select a project first.",
    selectFramework: "Select Framework / Platform",
    reactCode: "React Component Code",
    vueCode: "Vue Component Code",
    nuxtCode: "Nuxt Plugin Code",
    nextCode: "Next.js Component Code",
    wordpressCode: "WordPress PHP Code",
    generalGuide: "General Integration Guide",
    copyCode: "Copy Code",
    copyContent: "Copy Content",
    copied: "Copied!",
    installationInstructions: "Installation Instructions",
    changesSaved: "Changes Saved",
    changesSavedDescription:
      "Your widget settings have been saved successfully. Click the button below to get the integration code.",
    close: "Close",
    getIntegrationCode: "Get Integration Code",
    widgetUsage: "Usage:",
    widgetUsageVue: "Usage (App.vue or parent component):",
    widgetUsageNext: "Usage (app.tsx or page.tsx):",
    widgetNuxtPluginComment1: "// plugins/feedback-widget.client.js",
    widgetNuxtPluginComment2: "// This plugin automatically initializes all pages",
    widgetNuxtPluginComment3: "// Configured with tenantId: {tenantId}",
    widgetWpUrlComment: "// Widget URL - always loaded from feedpanels.com",
    widgetOtherScriptComment: "<!-- Load Widget script -->",
    // Installation instructions by framework
    reactInstall1: "Copy the component code above",
    reactInstall2:
      "Add the component to an appropriate location in your project (e.g., App.js or Layout component)",
    reactInstall3: "Import and render the component:",
    reactInstall4: "Save changes and refresh your application",
    reactInstall5:
      "Check that the widget button appears when the component is rendered",
    vueInstall1: "Copy the component code above",
    vueInstall2: "Add the component to the components folder in your project",
    vueInstall3: "Import and use it on the page where you want to use it",
    vueInstall4: "Save changes and refresh your application",
    vueInstall5:
      "Check that the widget button appears when the component is mounted",
    nuxtInstall1: "Copy the plugin code above",
    nuxtInstall2: "Save the code to",
    nuxtInstall3: "file",
    nuxtInstall4: "Nuxt will automatically load the plugin",
    nuxtInstall5: "Restart your application",
    nuxtInstall6: "Check that the widget button appears when the page loads",
    nextInstall1: "Copy the component code above",
    nextInstall2: "Save the component to",
    nextInstall3: "file",
    nextInstall4: "Import the component into your layout or page file:",
    nextInstall5: "Save changes and refresh your application",
    nextInstall6:
      "Check that the widget button appears when the page is rendered",
    wordpressInstall1: "Copy the PHP code above",
    wordpressInstall2: "Log in to WordPress admin panel",
    wordpressInstall3:
      "Go to Appearance → Theme Editor → Open functions.php file",
    wordpressInstall4: "Add the code to the end of the functions.php file",
    wordpressInstall5: "Save the file",
    wordpressInstall6:
      "Check that the widget button appears when you refresh the page",
    wordpressCodeComment: "WordPress: Add to your functions.php file",
    // Other framework guide
    otherUsage: "Usage on any website",
    otherInstallation: "Installation",
    otherInstallationDescription:
      "Add this single script tag to enable all FeedbackFlow embedding features:",
    otherFeature1: "Feature 1: Feedback Tool",
    otherFeature1Description: "Collect feedback from your users.",
    otherFeature1Details:
      'The widget automatically displays a "Feature Request" button at the bottom center of the page. When the button is clicked, a feedback modal opens and users can select one of the following feedback types:',
    otherFeature1Item1: "- Feature Request",
    otherFeature1Item2: "- Bug Report",
    otherFeature1Item3: "- Other",
    otherFeature1Item4: "",
    otherFeature2: "Feature 2: Roadmap Widget",
    otherFeature2Description:
      'Use the "Roadmap" button inside the modal to view your roadmap. This button opens your public roadmap page in a new tab.',
    otherFeature3: "Feature 3: Changelog Widget",
    otherFeature3Description:
      'Use the "Changelog" button inside the modal to view recent updates. This button opens your public changelog page in a new tab.',
    otherCustomization: "Customization",
    otherCustomizationDescription:
      "You can customize the widget appearance by changing the parameters in the init function:",
    otherParam1: "- tenantId: Your project's unique identifier",
    otherParam2:
      '- primaryColor: Button color (in hex format, e.g., "#0891b2")',
    otherParam3:
      '- backgroundColor: Modal background color (in hex format, e.g., "#ffffff")',
    otherParam4:
      '- buttonStyle: Button style ("rounded-full", "rounded-lg", "rounded", "rounded-none")',
    otherParam5: '- fontSize: Font size (e.g., "16px")',
    otherParam6: '- fontFamily: Font family (e.g., "Inter, sans-serif")',
    otherParam7: '- theme: Theme ("light" or "dark")',
    otherExample: "Example Usage",
    otherExampleBasic: "Basic setup:",
    otherNote:
      "Note: Add the widget just before the </body> tag of your website. The widget will automatically load and appear at the bottom center of the page.",
    // Changelog
    changelogTitle: "Changelog",
    changelogDescription: "Keep your users informed about updates",
    viewPublicChangelog: "View Public Changelog",
    newRelease: "New Release",
    createChangelogEntry: "Create Changelog Entry",
    createChangelogDescription: "Document your latest release or update",
    version: "Version",
    versionPlaceholder: "v2.1.0",
    title: "Title",
    titlePlaceholder: "Slack Integration & Performance Improvements",
    content: "Content",
    contentPlaceholder:
      "New Features:\n- Slack integration\n- Dark mode\n\nBug Fixes:\n- Fixed email notifications",
    publishChangelog: "Publish Changelog",
    loadingChangelog: "Loading changelog...",
    noChangelogEntries: "No changelog entries yet",
    createFirstReleaseNote: "Create your first release note",
    deleteChangelogEntry: "Delete Changelog Entry",
    deleteChangelogConfirm:
      "Are you sure you want to delete this changelog entry?",
    deleteChangelogWarning:
      "This action cannot be undone and the changelog will be removed from both the admin panel and public portal.",
    cancel: "Cancel",
    delete: "Delete",
    changelogCreated: "Changelog created",
    changelogCreateFailed: "Failed to create changelog",
    changelogDeleted: "Changelog deleted successfully",
    changelogDeleteFailed: "Failed to delete changelog",
    changelogLoadFailed: "Failed to load changelogs",
    pleaseSelectProject: "Please select a project first",
    // Roadmap
    productRoadmap: "Product Roadmap",
    roadmapDescription: "Plan and track your product features",
    newItem: "New Item",
    createRoadmapItem: "Create Roadmap Item",
    createRoadmapDescription: "Add a new feature or initiative to your roadmap",
    roadmapTitle: "Title",
    roadmapTitlePlaceholder: "Slack Integration",
    roadmapDescriptionLabel: "Description",
    roadmapDescriptionPlaceholder: "Integrate with Slack for notifications...",
    quarter: "Quarter",
    quarterPlaceholder: "Q2 2025",
    status: "Status",
    createItem: "Create Item",
    loadingRoadmap: "Loading roadmap...",
    noRoadmapItems: "No roadmap items yet",
    items: "items",
    fromFeedback: "From Feedback",
    votes: "votes",
    statusUpdated: "Status updated successfully",
    statusUpdateFailed: "Failed to update status",
    roadmapItemCreated: "Roadmap item created",
    roadmapItemCreateFailed: "Failed to create item",
    roadmapLoadFailed: "Failed to load roadmap",
    roadmapItemDeleted: "Roadmap item deleted. It has been removed from the public panel as well.",
    roadmapItemDeleteFailed: "Failed to delete roadmap item",
    deleteRoadmapItem: "Delete roadmap item",
    deleteRoadmapItemConfirm: "Are you sure you want to delete this item? It will also be removed from the public roadmap.",
    roadmapItemFromFeedbackCannotDelete: "This item comes from a feedback. You can only delete it from the Feedback panel.",
    // Roadmap Status Labels
    backlog: "Backlog",
    planned: "Planned",
    inDevelopment: "In Development",
    testing: "Testing",
    completed: "Completed",
    // Feedback
    feedbackTitle: "Geri Bildirim",
    feedbackDescription: "Manage customer feedback and requests",
    loadingFeedback: "Loading feedback...",
    noFeedbackYet: "No feedback yet",
    noFeedbackDescription: "Users can submit feedback via the public portal",
    loading: "Loading...",
    submittedBy: "Submitted by",
    anonymous: "Anonymous",
    description: "Description",
    updateStatus: "Update Status",
    upvotes: "Upvotes",
    views: "Views",
    deleteFeedback: "Delete Feedback",
    deleteFeedbackConfirm: "Are you sure you want to delete this feedback?",
    deleteFeedbackWarning:
      "This action cannot be undone. The feedback will be removed from:",
    adminPanel: "Admin panel",
    publicPortal: "Public portal",
    roadmap: "Roadmap",
    allRelatedVotes: "All related votes",
    cancel: "Cancel",
    delete: "Delete",
    feedbackDeleted: "Feedback deleted successfully",
    feedbackDeleteFailed: "Failed to delete feedback",
    feedbackLoadFailed: "Failed to load feedback",
    voteFailed: "Failed to vote",
    statusUpdated: "Status updated",
    statusUpdateFailed: "Failed to update status",
    // Feedback Type Labels
    feature: "Feature",
    bug: "Bug",
    improvement: "Improvement",
    other: "Other",
    // Priority Labels
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    // Comments
    comments: "Comments",
    comment: "Comment",
    writeComment: "Write your comment...",
    submitComment: "Submit Comment",
    commentSubmitted: "Comment submitted",
    commentSubmitFailed: "Failed to submit comment",
    commentRequired: "Comment cannot be empty",
    commentsLoadFailed: "Failed to load comments",
    failedToLoadComments: "Failed to load comments",
    failedToSubmitComment: "Failed to submit comment",
    noCommentsYet: "No comments yet. Be the first to comment!",
    reply: "Reply",
    writeReply: "Write your reply...",
    sendReply: "Send Reply",
    replySubmitted: "Reply submitted",
    replySubmitFailed: "Failed to submit reply",
    cancelReply: "Cancel",
    internal: "Internal",
    public: "Public",
    projectSettings: "Project Settings",
    enableComments: "Enable Comments",
    enableCommentsDescription: "Allow users to comment on feedbacks",
    commentsEnabled: "Comments enabled",
    commentsDisabled: "Comments disabled",
    settingsUpdateFailed: "Failed to update settings",
    unsavedChangesTitle: "Unsaved Changes",
    unsavedChangesMessage:
      "You have unsaved changes in your customization settings. If you proceed to the integration code, these changes will be lost and the code will be different from your current settings.",
    continueAnyway: "Continue Anyway",
    // Dashboard
    welcomeBack: "Welcome back! 👋",
    dashboardIntro: "Here's what's happening with your feedback:",
    totalFeedback: "Total Feedback",
    allTime: "All time",
    activeFeedback: "Active Feedback",
    inProgress: "In progress",
    thisMonth: "This Month",
    newSubmissions: "New submissions",
    topFeedback: "Top Feedback",
    noFeedbackYet: "No feedback yet",
    yourProjects: "Your Projects",
    active: "Active",
    created: "Created",
    quickActions: "Quick Actions",
    viewAllFeedback: "View All Feedback",
    manageRoadmap: "Manage Roadmap",
    setupWidget: "Setup Widget",
    publicPages: "Public Pages",
    publicFeedback: "Public Feedback",
    publicRoadmap: "Public Roadmap",
    publicChangelog: "Public Changelog",
    selectProjectToViewPublicPages: "Select a project to view public pages",
    ipAddress: "IP Address",
    daysRemaining: "Days Remaining",
    status: "Status",
    statsLoadFailed: "Failed to load statistics",
    welcomeToFeedbackFlow: "Welcome to FeedbackFlow! 🎉",
    firstProjectModalDescription:
      "Create your first project to get started. A project name helps you organize your feedback.",
    moreProjectsHint: "💡 You can add more projects anytime",
    createProject: "Create Project",
    creatingProject: "Creating...",
    projectNamePlaceholder: "Ex: My Web App",
    pleaseEnterProjectName: "Please enter project name",
    projectCreatedWelcome: "Project created! Welcome to FeedbackFlow!",
    howToIntegrateButton: "How to integrate?",
    integrationGuideTitle: "Integration Guide",
    integrationPreStep: "Before You Begin",
    integrationPreStepDesc: "Before you begin, please create your project and do not forget to assign a domain name to the project you have created. If your project and domain name are already created, ensure that the project you want to integrate is selected as the active project.",
    integrationStep1: "Go to the 'Integration' tab from the Dashboard menu",
    integrationStep1Desc: "Click on the 'Integration' or 'Widget' tab from the left menu to access the integration page. Here you can customize your widget and get the integration code.",
    integrationStep2: "Customize your widget settings (color, position, style, etc.)",
    integrationStep2Desc: "Customize your widget's appearance to match your brand. You can change settings like color, button style, font family, and size. Click the 'Save' button to save your changes.",
    integrationStep3: "Copy the integration code for your framework",
    integrationStep3Desc: "Go to the 'Integration Code' tab and select your framework (React, Vue, Next.js, WordPress, etc.). Copy the code prepared for your selected framework.",
    integrationStep4: "Add the code to the appropriate place on your website",
    integrationStep4Desc: "Paste the copied code into the appropriate place on your website. Usually, you need to add the widget component to your main layout file or root component. The code will automatically load the widget.",
    integrationStep5: "Your widget is now ready to use!",
    integrationStep5Desc: "After adding the code, refresh your website. The widget button will appear at the bottom of your page. Users can click this button to submit feedback.\n\nNote: Your Tenant ID has been automatically embedded in the integration code. This ID determines which project the feedback will be sent to. You can view your Tenant ID in the Widget integration code.",
    previous: "Previous",
    next: "Next",
    purchaseLicense: "Purchase License",
    // Public Portal
    publicPortal: "Public Portal",
    feedbackNav: "Feedback",
    roadmapNav: "Roadmap",
    changelogNav: "Changelog",
    feedbackTitle: "💬 Feedback",
    feedbackDescription: "Share your feedback and ideas",
    submitFeedback: "Submit Feedback",
    submitYourFeedback: "Submit Your Feedback",
    helpUsImprove: "Help us improve by sharing your ideas and suggestions",
    feedbackType: "Feedback Type",
    featureRequest: "Feature Request",
    bugReport: "Bug Report",
    improvement: "Improvement",
    other: "Other",
    title: "Title",
    briefDescription: "Brief description of your feedback",
    description: "Description",
    provideMoreDetails: "Provide more details about your feedback...",
    yourName: "Your Name",
    yourEmail: "Your Email",
    feedbackSubmittedSuccess:
      "Feedback submitted successfully! It will be visible after review.",
    projectNotFound: "Project Not Found",
    projectNotFoundDescription: "The project you're looking for doesn't exist",
    projectNotFoundText:
      "The project you're trying to access doesn't exist or hasn't been set up yet.",
    contactAdministrator:
      "Please contact the administrator, then try accessing the public page again.",
    all: "All",
    backlog: "Backlog",
    planned: "Planned",
    inDevelopment: "In Development",
    testing: "Testing",
    completed: "Completed",
    new: "New",
    underReview: "Under Review",
    inProgress: "In Progress",
    mostVoted: "Most Voted",
    newestFirst: "Newest First",
    oldestFirst: "Oldest First",
    noFeedbackYet: "No feedback yet",
    beFirstToShare: "Be the first to share your thoughts!",
    views: "views",
    by: "by",
    voteSaved: "Your vote has been saved!",
    voteRemoved: "Vote removed",
    failedToVote: "Failed to vote. Please try again.",
    failedToLoadFeedback: "Failed to load feedback",
    loading: "Loading...",
    productRoadmap: "Product Roadmap",
    seeWhatWeWorkingOn: "See what we're working on and what's coming next",
    noRoadmapItemsYet: "No roadmap items yet",
    items: "items",
    loadingRoadmap: "Loading roadmap...",
    failedToLoadRoadmap: "Failed to load roadmap",
    changelog: "Changelog",
    stayUpdated: "Stay updated with our latest releases and improvements",
    noReleasesYet: "No releases yet",
    checkBackSoon: "Check back soon for updates",
    loadingChangelog: "Loading changelog...",
    failedToLoadChangelog: "Failed to load changelog",
    boardNotFound: "Board Not Found",
    boardNotFoundDescription: "The board you're looking for doesn't exist",
    boardNotFoundText:
      "The board you're trying to access doesn't exist or hasn't been set up yet.",
    contactAdminToSetup:
      "Please contact the administrator to set up a board, then try accessing the public page again.",
    selectCategory: "Select a category",
    category: "Category",
    poweredBy: "Powered by",
    footerCopyright: `© ${new Date().getFullYear()} Created by ZeuZ IT`,
    privacyPolicy: "Privacy Policy",
    legalNotice: "Legal Notice",
    // Inactive Project Modal
    inactiveProjectTitle: "⚠️ Inactive Project",
    inactiveProjectMessage: "This project is not active. You cannot use integrations or initialize the widget for this project.",
    inactiveProjectExplanation: "To activate this project, go to Plan Management → Active Projects and enable it.",
    activate: "Activate & Open",
    activatingProject: "Activating...",
    goToPlanManagement: "Manage All",
    cancel: "Cancel",
    maxActiveProjectsReached: "Maximum active projects reached",
    activationFailed: "Failed to activate project",
    projectActivated: "Project activated successfully",
    projectDeactivated: "Project deactivated successfully",
    pendingDowngradeTitle: "Plan Change Already Pending",
    pendingDowngradeMessage: "Your change to the {plan} plan is scheduled for {date}. Please wait for the process to complete.",
    ok: "OK",
  },
  de: {
    dashboard: "Dashboard",
    feedback: "Rückmeldung",
    roadmap: "Roadmap",
    changelog: "Änderungsprotokoll",
    widget: "Integrationen",
    users: "Benutzer",
    contact: "Kontakt",
    planManagement: "Planverwaltung",
    settings: "Einstellungen",
    upgrade: "Upgrade",
    language: "Sprache",
    activeProject: "Aktives Projekt",
    addProject: "Projekt Hinzufügen",
    addProjectMobile: "Hinzufügen",
    logout: "Abmelden",
    exitMobile: "Abmelden",
    purchaseNow: "Jetzt kaufen",
    createNewProject: "Neues Projekt Erstellen",
    addNewProject:
      "Fügen Sie ein neues Projekt hinzu, um Ihr Feedback zu organisieren",
    projectName: "Projektname",
    projectNamePlaceholder: "Bsp: Meine Web-App",
    domain: "Domain (Optional)",
    domainPlaceholder: "example.com oder *.example.com",
    domainHint: "Sie können Domains später in den Widget-Einstellungen hinzufügen oder ändern",
    invalidDomainFormat: "Ungültiges Domain-Format. Beispiel: example.com oder *.example.com",
    createProject: "Projekt Erstellen",
    contactTitle: "Kontakt",
    contactDescription: "Kontaktieren Sie uns",
    sendMessage: "Nachricht Senden",
    contactDescriptionText:
      "Kontaktieren Sie uns für Ihre Fragen oder Vorschläge",
    contactModalTitle: "Kontaktieren Sie uns zum Enterprise-Plan",
    contactModalDescription: "Senden Sie Ihre Anfrage, wir melden uns schnellstmöglich. Es werden dieselben SMTP-Einstellungen wie beim Kontaktformular der Landingpage verwendet.",
    yourName: "Ihr Name",
    email: "E-Mail",
    subject: "Betreff",
    message: "Ihre Nachricht",
    messagePlaceholder: "Schreiben Sie Ihre Nachricht hier...",
    subjectPlaceholder: "Nachrichtenbetreff",
    sending: "Wird gesendet...",
    messageSent: "Ihre Nachricht wurde erfolgreich gesendet!",
    messageFailed:
      "Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    allFieldsRequired: "Bitte füllen Sie alle Felder aus",
    pleaseFillThisField: "Bitte füllen Sie dieses Feld aus",
    projectCreated: "Projekt erfolgreich erstellt!",
    projectCreateFailed: "Projekt konnte nicht erstellt werden",
    // Team/Users
    usersTitle: "Benutzer",
    usersDescription: "Projekt-Benutzer, die Feedback abgegeben haben",
    usersDescriptionNoProject:
      "Benutzer, die Feedback zum Projekt abgegeben haben",
    noUsersYet: "Noch keine Benutzer",
    noUsersDescription:
      "Benutzer, die Feedback zum Projekt abgeben, werden hier angezeigt",
    anonymous: "Anonym",
    feedbacks: "Feedbacks",
    lastActivity: "Letzte Aktivität",
    userActivityHistory: "Benutzeraktivitätsverlauf",
    submittedFeedbacks: "Abgegebene Feedbacks",
    noFeedbacksYet: "Dieser Benutzer hat noch kein Feedback abgegeben",
    loading: "Wird geladen...",
    type: "Typ",
    status: "Status",
    // Widget
    widgetIntegration: "Widget-Integration",
    widgetDescription:
      "Fügen Sie das Feedback-Widget zu Ihrer Website hinzu und passen Sie es an",
    customize: "Anpassen",
    integrationCode: "Integrationscode",
    widgetSettings: "Widget-Einstellungen",
    widgetSettingsDescription:
      "Passen Sie das Erscheinungsbild und Verhalten des Widgets an",
    buttonColor: "Button-Farbe",
    backgroundColor: "Hintergrundfarbe",
    buttonStyle: "Button-Stil",
    rounded: "Rund",
    roundedLarge: "Abgerundete Ecken",
    roundedSmall: "Leicht abgerundet",
    roundedNone: "Eckig",
    fontFamily: "Schriftart",
    fontSize: "Schriftgröße",
    small: "Klein",
    medium: "Mittel",
    large: "Groß",
    veryLarge: "Sehr groß",
    theme: "Thema",
    darkMode: "Dunkler Modus",
    lightMode: "Heller Modus",
    buttonPosition: "Button-Position (Optional)",
    buttonPositionPlaceholder: "#blog-footer oder .feedback-section",
    buttonPositionDescription:
      "Wenn leer gelassen, erscheint es in der unteren Mitte der Seite. Geben Sie einen CSS-Selektor ein (z.B. #container-id oder .class-name)",
    save: "Speichern",
    livePreview: "Live-Vorschau",
    livePreviewDescription:
      "Sehen Sie, wie das Widget auf Ihrer Website erscheinen wird",
    websiteContent: "Ihr Website-Inhalt wird hier angezeigt",
    feedback: "Rückmeldung",
    featureRequest: "Feature-Anfrage",
    bug: "Fehler",
    other: "Sonstiges",
    roadmap: "Roadmap",
    changelog: "Änderungsprotokoll",
    title: "Titel",
    titlePlaceholder: "Kurze Beschreibung Ihres Feedbacks",
    description: "Beschreibung",
    descriptionPlaceholder: "Geben Sie weitere Details zu Ihrem Feedback an...",
    yourName: "Ihr Name",
    yourNamePlaceholder: "Max Mustermann",
    yourEmail: "Ihre E-Mail",
    yourEmailPlaceholder: "max@beispiel.de",
    submitFeedback: "Feedback absenden",
    feedbackSubmitted: "Feedback gesendet! (Vorschaumodus)",
    activeProjectNotFound:
      "Aktives Projekt nicht gefunden. Bitte wählen Sie zuerst ein Projekt aus.",
    selectFramework: "Framework / Plattform auswählen",
    reactCode: "React-Component-Code",
    vueCode: "Vue-Component-Code",
    nuxtCode: "Nuxt-Plugin-Code",
    nextCode: "Next.js-Component-Code",
    wordpressCode: "WordPress-PHP-Code",
    generalGuide: "Allgemeiner Integrationsleitfaden",
    copyCode: "Code kopieren",
    copyContent: "Inhalt kopieren",
    copied: "Kopiert!",
    installationInstructions: "Installationsanweisungen",
    changesSaved: "Änderungen gespeichert",
    changesSavedDescription:
      "Ihre Widget-Einstellungen wurden erfolgreich gespeichert. Klicken Sie auf die Schaltfläche unten, um den Integrationscode zu erhalten.",
    close: "Schließen",
    getIntegrationCode: "Integrationscode abrufen",
    widgetUsage: "Verwendung:",
    widgetUsageVue: "Verwendung (App.vue oder Elternkomponente):",
    widgetUsageNext: "Verwendung (app.tsx oder page.tsx):",
    widgetNuxtPluginComment1: "// plugins/feedback-widget.client.js",
    widgetNuxtPluginComment2: "// Dieses Plugin initialisiert automatisch alle Seiten",
    widgetNuxtPluginComment3: "// Konfiguriert mit tenantId: {tenantId}",
    widgetWpUrlComment: "// Widget-URL - wird immer von feedpanels.com geladen",
    widgetOtherScriptComment: "<!-- Widget-Skript laden -->",
    // Installation instructions by framework
    reactInstall1: "Kopieren Sie den Component-Code oben",
    reactInstall2:
      "Fügen Sie die Component an einer geeigneten Stelle in Ihrem Projekt hinzu (z.B. App.js oder Layout-Component)",
    reactInstall3: "Importieren und rendern Sie die Component:",
    reactInstall4:
      "Speichern Sie die Änderungen und aktualisieren Sie Ihre Anwendung",
    reactInstall5:
      "Überprüfen Sie, dass der Widget-Button erscheint, wenn die Component gerendert wird",
    vueInstall1: "Kopieren Sie den Component-Code oben",
    vueInstall2:
      "Fügen Sie die Component zum components-Ordner in Ihrem Projekt hinzu",
    vueInstall3:
      "Importieren und verwenden Sie sie auf der Seite, auf der Sie sie verwenden möchten",
    vueInstall4:
      "Speichern Sie die Änderungen und aktualisieren Sie Ihre Anwendung",
    vueInstall5:
      "Überprüfen Sie, dass der Widget-Button erscheint, wenn die Component gemountet wird",
    nuxtInstall1: "Kopieren Sie den Plugin-Code oben",
    nuxtInstall2: "Speichern Sie den Code in",
    nuxtInstall3: "Datei",
    nuxtInstall4: "Nuxt lädt das Plugin automatisch",
    nuxtInstall5: "Starten Sie Ihre Anwendung neu",
    nuxtInstall6:
      "Überprüfen Sie, dass der Widget-Button erscheint, wenn die Seite geladen wird",
    nextInstall1: "Kopieren Sie den Component-Code oben",
    nextInstall2: "Speichern Sie die Component in",
    nextInstall3: "Datei",
    nextInstall4:
      "Importieren Sie die Component in Ihre Layout- oder Seiten-Datei:",
    nextInstall5:
      "Speichern Sie die Änderungen und aktualisieren Sie Ihre Anwendung",
    nextInstall6:
      "Überprüfen Sie, dass der Widget-Button erscheint, wenn die Seite gerendert wird",
    wordpressInstall1: "Kopieren Sie den PHP-Code oben",
    wordpressInstall2: "Melden Sie sich im WordPress-Admin-Panel an",
    wordpressInstall3:
      "Gehen Sie zu Design → Theme-Editor → Öffnen Sie die functions.php-Datei",
    wordpressInstall4:
      "Fügen Sie den Code am Ende der functions.php-Datei hinzu",
    wordpressInstall5: "Speichern Sie die Datei",
    wordpressInstall6:
      "Überprüfen Sie, dass der Widget-Button erscheint, wenn Sie die Seite aktualisieren",
    wordpressCodeComment: "WordPress: Zu Ihrer functions.php-Datei hinzufügen",
    // Other framework guide
    otherUsage: "Verwendung auf jeder Website",
    otherInstallation: "Installation",
    otherInstallationDescription:
      "Fügen Sie dieses einzelne Skript-Tag hinzu, um alle FeedbackFlow-Einbettungsfunktionen zu aktivieren:",
    otherFeature1: "Funktion 1: Feedback-Tool",
    otherFeature1Description: "Sammeln Sie Feedback von Ihren Benutzern.",
    otherFeature1Details:
      'Das Widget zeigt automatisch einen "Feature Request"-Button in der unteren Mitte der Seite an. Wenn der Button angeklickt wird, öffnet sich ein Feedback-Modal und Benutzer können einen der folgenden Feedback-Typen auswählen:',
    otherFeature1Item1: "- Feature-Anfrage",
    otherFeature1Item2: "- Fehlerbericht",
    otherFeature1Item3: "- Sonstiges",
    otherFeature1Item4: "",
    otherFeature2: "Funktion 2: Roadmap-Widget",
    otherFeature2Description:
      'Verwenden Sie den "Roadmap"-Button im Modal, um Ihre Roadmap anzuzeigen. Dieser Button öffnet Ihre öffentliche Roadmap-Seite in einem neuen Tab.',
    otherFeature3: "Funktion 3: Changelog-Widget",
    otherFeature3Description:
      'Verwenden Sie den "Changelog"-Button im Modal, um aktuelle Updates anzuzeigen. Dieser Button öffnet Ihre öffentliche Changelog-Seite in einem neuen Tab.',
    otherCustomization: "Anpassung",
    otherCustomizationDescription:
      "Sie können das Erscheinungsbild des Widgets anpassen, indem Sie die Parameter in der init-Funktion ändern:",
    otherParam1: "- tenantId: Eindeutige Kennung Ihres Projekts",
    otherParam2: '- primaryColor: Button-Farbe (im Hex-Format, z.B. "#0891b2")',
    otherParam3:
      '- backgroundColor: Modal-Hintergrundfarbe (im Hex-Format, z.B. "#ffffff")',
    otherParam4:
      '- buttonStyle: Button-Stil ("rounded-full", "rounded-lg", "rounded", "rounded-none")',
    otherParam5: '- fontSize: Schriftgröße (z.B. "16px")',
    otherParam6: '- fontFamily: Schriftart (z.B. "Inter, sans-serif")',
    otherParam7: '- theme: Thema ("light" oder "dark")',
    otherExample: "Beispielverwendung",
    otherExampleBasic: "Grundkonfiguration:",
    otherNote:
      "Hinweis: Fügen Sie das Widget direkt vor dem </body>-Tag Ihrer Website hinzu. Das Widget wird automatisch geladen und erscheint in der unteren Mitte der Seite.",
    // Changelog
    changelogTitle: "Änderungsprotokoll",
    changelogDescription: "Halten Sie Ihre Benutzer über Updates informiert",
    viewPublicChangelog: "Öffentliches Changelog anzeigen",
    newRelease: "Neue Version",
    createChangelogEntry: "Changelog-Eintrag erstellen",
    createChangelogDescription:
      "Dokumentieren Sie Ihre neueste Version oder Aktualisierung",
    version: "Version",
    versionPlaceholder: "v2.1.0",
    title: "Titel",
    titlePlaceholder: "Slack-Integration & Leistungsverbesserungen",
    content: "Inhalt",
    contentPlaceholder:
      "Neue Funktionen:\n- Slack-Integration\n- Dunkler Modus\n\nFehlerbehebungen:\n- E-Mail-Benachrichtigungen behoben",
    publishChangelog: "Changelog veröffentlichen",
    loadingChangelog: "Changelog wird geladen...",
    noChangelogEntries: "Noch keine Changelog-Einträge",
    createFirstReleaseNote: "Erstellen Sie Ihre erste Versionsnotiz",
    deleteChangelogEntry: "Changelog-Eintrag löschen",
    deleteChangelogConfirm:
      "Sind Sie sicher, dass Sie diesen Changelog-Eintrag löschen möchten?",
    deleteChangelogWarning:
      "Diese Aktion kann nicht rückgängig gemacht werden und der Changelog wird sowohl aus dem Admin-Panel als auch aus dem öffentlichen Portal entfernt.",
    cancel: "Abbrechen",
    delete: "Löschen",
    changelogCreated: "Changelog erstellt",
    changelogCreateFailed: "Fehler beim Erstellen des Changelogs",
    changelogDeleted: "Changelog erfolgreich gelöscht",
    changelogDeleteFailed: "Fehler beim Löschen des Changelogs",
    changelogLoadFailed: "Fehler beim Laden der Changelogs",
    pleaseSelectProject: "Bitte wählen Sie zuerst ein Projekt aus",
    // Roadmap
    productRoadmap: "Produkt-Roadmap",
    roadmapDescription: "Planen und verfolgen Sie Ihre Produktfunktionen",
    newItem: "Neues Element",
    createRoadmapItem: "Roadmap-Element erstellen",
    createRoadmapDescription:
      "Fügen Sie eine neue Funktion oder Initiative zu Ihrer Roadmap hinzu",
    roadmapTitle: "Titel",
    roadmapTitlePlaceholder: "Slack-Integration",
    roadmapDescriptionLabel: "Beschreibung",
    roadmapDescriptionPlaceholder:
      "Integration mit Slack für Benachrichtigungen...",
    quarter: "Quartal",
    quarterPlaceholder: "Q2 2025",
    status: "Status",
    createItem: "Element erstellen",
    loadingRoadmap: "Roadmap wird geladen...",
    noRoadmapItems: "Noch keine Roadmap-Elemente",
    items: "Elemente",
    fromFeedback: "Aus Feedback",
    votes: "Stimmen",
    statusUpdated: "Status erfolgreich aktualisiert",
    statusUpdateFailed: "Fehler beim Aktualisieren des Status",
    roadmapItemCreated: "Roadmap-Element erstellt",
    roadmapItemCreateFailed: "Fehler beim Erstellen des Elements",
    roadmapLoadFailed: "Fehler beim Laden der Roadmap",
    roadmapItemDeleted: "Roadmap-Element gelöscht. Es wurde auch aus dem öffentlichen Panel entfernt.",
    roadmapItemDeleteFailed: "Roadmap-Element konnte nicht gelöscht werden",
    deleteRoadmapItem: "Roadmap-Element löschen",
    deleteRoadmapItemConfirm: "Möchten Sie dieses Element wirklich löschen? Es wird auch von der öffentlichen Roadmap entfernt.",
    roadmapItemFromFeedbackCannotDelete: "Dieses Element stammt von einem Feedback. Es kann nur im Feedback-Bereich gelöscht werden.",
    // Roadmap Status Labels
    backlog: "Warteschlange",
    planned: "Geplant",
    inDevelopment: "In Entwicklung",
    testing: "Wird getestet",
    completed: "Abgeschlossen",
    // Feedback
    feedbackTitle: "Rückmeldung",
    feedbackDescription: "Verwalten Sie Kundenfeedback und Anfragen",
    loadingFeedback: "Feedback wird geladen...",
    noFeedbackYet: "Noch kein Feedback",
    noFeedbackDescription:
      "Benutzer können Feedback über das öffentliche Portal einreichen",
    loading: "Wird geladen...",
    submittedBy: "Eingereicht von",
    anonymous: "Anonym",
    description: "Beschreibung",
    updateStatus: "Status aktualisieren",
    upvotes: "Stimmen",
    views: "Aufrufe",
    deleteFeedback: "Feedback löschen",
    deleteFeedbackConfirm:
      "Sind Sie sicher, dass Sie dieses Feedback löschen möchten?",
    deleteFeedbackWarning:
      "Diese Aktion kann nicht rückgängig gemacht werden. Das Feedback wird entfernt von:",
    adminPanel: "Admin-Panel",
    publicPortal: "Öffentliches Portal",
    roadmap: "Roadmap",
    allRelatedVotes: "Alle zugehörigen Stimmen",
    cancel: "Abbrechen",
    delete: "Löschen",
    feedbackDeleted: "Feedback erfolgreich gelöscht",
    feedbackDeleteFailed: "Fehler beim Löschen des Feedbacks",
    feedbackLoadFailed: "Fehler beim Laden des Feedbacks",
    voteFailed: "Fehler beim Abstimmen",
    statusUpdated: "Status aktualisiert",
    statusUpdateFailed: "Fehler beim Aktualisieren des Status",
    // Feedback Type Labels
    feature: "Feature",
    bug: "Fehler",
    improvement: "Verbesserung",
    other: "Sonstiges",
    // Priority Labels
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    urgent: "Dringend",
    // Comments
    comments: "Kommentare",
    comment: "Kommentar",
    writeComment: "Schreiben Sie Ihren Kommentar...",
    submitComment: "Kommentar absenden",
    commentSubmitted: "Kommentar gesendet",
    commentSubmitFailed: "Fehler beim Senden des Kommentars",
    commentRequired: "Kommentar darf nicht leer sein",
    commentsLoadFailed: "Fehler beim Laden der Kommentare",
    failedToLoadComments: "Fehler beim Laden der Kommentare",
    failedToSubmitComment: "Fehler beim Senden des Kommentars",
    noCommentsYet: "Noch keine Kommentare. Seien Sie der Erste!",
    reply: "Antworten",
    writeReply: "Schreiben Sie Ihre Antwort...",
    sendReply: "Antwort senden",
    replySubmitted: "Antwort gesendet",
    replySubmitFailed: "Fehler beim Senden der Antwort",
    cancelReply: "Abbrechen",
    internal: "Intern",
    public: "Öffentlich",
    projectSettings: "Projekteinstellungen",
    enableComments: "Kommentare aktivieren",
    enableCommentsDescription: "Benutzern erlauben, Feedback zu kommentieren",
    commentsEnabled: "Kommentare aktiviert",
    commentsDisabled: "Kommentare deaktiviert",
    settingsUpdateFailed: "Einstellungen konnten nicht aktualisiert werden",
    unsavedChangesTitle: "Nicht gespeicherte Änderungen",
    unsavedChangesMessage:
      "Sie haben nicht gespeicherte Änderungen in Ihren Anpassungseinstellungen. Wenn Sie zum Integrationscode wechseln, gehen diese Änderungen verloren und der Code unterscheidet sich von Ihren aktuellen Einstellungen.",
    continueAnyway: "Trotzdem fortfahren",
    // Dashboard
    welcomeBack: "Willkommen zurück! 👋",
    dashboardIntro: "Das ist der aktuelle Stand Ihres Feedbacks:",
    totalFeedback: "Gesamtes Feedback",
    allTime: "Gesamt",
    activeFeedback: "Aktives Feedback",
    inProgress: "In Bearbeitung",
    thisMonth: "Diesen Monat",
    newSubmissions: "Neue Einreichungen",
    topFeedback: "Top Feedback",
    noFeedbackYet: "Noch kein Feedback",
    yourProjects: "Ihre Projekte",
    active: "Aktiv",
    created: "Erstellt",
    quickActions: "Schnellaktionen",
    viewAllFeedback: "Alle Feedbacks anzeigen",
    manageRoadmap: "Roadmap verwalten",
    setupWidget: "Widget einrichten",
    publicPages: "Öffentliche Seiten",
    publicFeedback: "Öffentliches Feedback",
    publicRoadmap: "Öffentliche Roadmap",
    publicChangelog: "Öffentliches Änderungsprotokoll",
    selectProjectToViewPublicPages:
      "Wählen Sie ein Projekt aus, um öffentliche Seiten anzuzeigen",
    ipAddress: "IP-Adresse",
    daysRemaining: "Verbleibende Tage",
    status: "Status",
    statsLoadFailed: "Fehler beim Laden der Statistiken",
    welcomeToFeedbackFlow: "Willkommen bei FeedbackFlow! 🎉",
    firstProjectModalDescription:
      "Erstellen Sie Ihr erstes Projekt, um loszulegen. Ein Projektname hilft Ihnen, Ihr Feedback zu organisieren.",
    moreProjectsHint: "💡 Sie können jederzeit weitere Projekte hinzufügen",
    createProject: "Projekt erstellen",
    creatingProject: "Wird erstellt...",
    // Login & Register
    welcomeBack: "Willkommen zurück",
    signInToContinue: "Melden Sie sich in Ihrem Konto an, um fortzufahren",
    emailLabel: "E-Mail",
    emailPlaceholder: "sie@unternehmen.com",
    passwordLabel: "Passwort",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Passwort vergessen?",
    signIn: "Anmelden",
    signingIn: "Wird angemeldet...",
    dontHaveAccount: "Haben Sie noch kein Konto?",
    signUp: "Registrieren",
    createAccount: "Konto erstellen",
    getStarted: "Beginnen Sie mit Ihrem kostenlosen Konto",
    companyName: "Firmenname",
    companyNamePlaceholder: "Acme GmbH",
    passwordRequirements: "Passwortanforderungen",
    minLength: "Mindestens 8 Zeichen",
    hasUpperCase: "Mindestens ein Großbuchstabe",
    hasLowerCase: "Mindestens ein Kleinbuchstabe",
    hasNumber: "Mindestens eine Zahl",
    hasSpecialChar: "Mindestens ein Sonderzeichen",
    acceptTermsAndPrivacy: "Ich akzeptiere die Nutzungsbedingungen und die Datenschutzerklärung.",
    termsAndPrivacyRequired: "Sie müssen die Nutzungsbedingungen und die Datenschutzerklärung akzeptieren.",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    creatingAccount: "Konto wird erstellt...",
    incorrectEmailOrPassword: "Falsche E-Mail oder Passwort",
    emailNotRegistered: "Diese E-Mail-Adresse ist nicht im System registriert",
    incorrectPassword: "Passwort ist falsch, bitte versuchen Sie es erneut",
    emailNotFound: "Kein Konto mit dieser E-Mail-Adresse gefunden",
    invalidEmailFormat: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordRequirementsNotMet: "Bitte erfüllen Sie die Passwortanforderungen",
    registrationFailed: "Registrierung fehlgeschlagen",
    registrationSuccessful: "Registrierung erfolgreich!",
    loginSuccess: "Anmeldung erfolgreich!",
    emailAlreadyRegistered: "Diese E-Mail-Adresse ist bereits registriert",
    backendConnectionError: "Verbindung zum Backend-Server nicht möglich. Bitte stellen Sie sicher, dass der Backend-Server läuft.",
    // Google OAuth
    orContinueWith: "Oder fortfahren mit",
    googleSignIn: "Mit Google anmelden",
    googleSignUp: "Mit Google registrieren",
    googleLoginError: "Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    signingInWithGoogle: "Anmeldung mit Google...",
    // Email Verification
    verificationEmailSent: "Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mail-Adresse.",
    verifying: "Wird überprüft...",
    emailVerified: "E-Mail verifiziert",
    emailNotVerified: "Ihre E-Mail-Adresse wurde nicht verifiziert. Bitte überprüfen Sie Ihre E-Mails und verifizieren Sie Ihr Konto.",
    emailVerificationRequired: "E-Mail-Verifizierung erforderlich. Bitte überprüfen Sie Ihre E-Mails und klicken Sie auf den Verifizierungslink.",
    verificationError: "Verifizierungsfehler",
    verificationSuccess: "Ihre E-Mail-Adresse wurde erfolgreich verifiziert. Bitte melden Sie sich an.",
    verificationInProgress: "Bitte warten Sie...",
    redirectingToLogin: "Sie werden auf die Anmeldeseite weitergeleitet...",
    verificationFailed: "Verifizierung fehlgeschlagen. Bitte versuchen Sie, ein neues Konto zu erstellen, oder kontaktieren Sie den Support.",
    registerAgain: "Erneut registrieren",
    invalidOrExpiredToken: "Verifizierungstoken ist ungültig oder abgelaufen",
    // Password Reset
    resetPasswordTitle: "Passwort zurücksetzen",
    resetPassword: "Passwort Zurücksetzen",
    resettingPassword: "Passwort wird zurückgesetzt...",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort Bestätigen",
    passwordResetSuccess: "Ihr Passwort wurde erfolgreich zurückgesetzt. Bitte melden Sie sich an.",
    passwordResetError: "Fehler beim Zurücksetzen des Passworts",
    passwordResetFailed: "Passwort-Reset fehlgeschlagen.",
    requestNewLink: "Neuen Link anfordern",
    enterNewPassword: "Geben Sie Ihr neues Passwort ein",
    // Forgot Password
    forgotPasswordTitle: "Passwort vergessen",
    forgotPasswordDescription: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen des Passworts",
    checkYourEmail: "Überprüfen Sie Ihre E-Mail",
    passwordResetLinkSent: "Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail gesendet!",
    passwordResetLinkSentTo: "Link zum Zurücksetzen des Passworts wurde gesendet an",
    checkEmailInbox: "Bitte überprüfen Sie Ihren E-Mail-Posteingang. Wenn Sie die E-Mail nicht sehen, überprüfen Sie Ihren Spam-Ordner.",
    sendNewEmail: "Neue E-Mail senden",
    sending: "Wird gesendet...",
    sendPasswordResetLink: "Link zum Zurücksetzen des Passworts senden",
    backToSignIn: "Zurück zur Anmeldung",
    errorOccurred: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    projectNamePlaceholder: "Bsp: Meine Web-App",
    pleaseEnterProjectName: "Bitte geben Sie einen Projektnamen ein",
    projectCreatedWelcome: "Projekt erstellt! Willkommen bei FeedbackFlow!",
    howToIntegrateButton: "Wie integriere ich?",
    integrationGuideTitle: "Integrationsanleitung",
    integrationPreStep: "Bevor Sie beginnen",
    integrationPreStepDesc: "Bevor Sie beginnen, erstellen Sie bitte Ihr Projekt und vergessen Sie nicht, dem erstellten Projekt einen Domain-Namen zuzuweisen. Wenn Ihr Projekt und Ihre Domain bereits erstellt wurden, stellen Sie sicher, dass das Projekt, das Sie integrieren möchten, als aktives Projekt ausgewählt ist.",
    integrationStep1: "Gehen Sie zum 'Integration'-Tab im Dashboard-Menü",
    integrationStep1Desc: "Klicken Sie auf den 'Integration'- oder 'Widget'-Tab im linken Menü, um zur Integrationsseite zu gelangen. Hier können Sie Ihr Widget anpassen und den Integrationscode erhalten.",
    integrationStep2: "Passen Sie Ihre Widget-Einstellungen an (Farbe, Position, Stil usw.)",
    integrationStep2Desc: "Passen Sie das Erscheinungsbild Ihres Widgets an Ihre Marke an. Sie können Einstellungen wie Farbe, Button-Stil, Schriftart und -größe ändern. Klicken Sie auf die Schaltfläche 'Speichern', um Ihre Änderungen zu speichern.",
    integrationStep3: "Kopieren Sie den Integrationscode für Ihr Framework",
    integrationStep3Desc: "Gehen Sie zum Tab 'Integrationscode' und wählen Sie Ihr Framework aus (React, Vue, Next.js, WordPress usw.). Kopieren Sie den Code, der für Ihr ausgewähltes Framework vorbereitet wurde.",
    integrationStep4: "Fügen Sie den Code an der entsprechenden Stelle auf Ihrer Website ein",
    integrationStep4Desc: "Fügen Sie den kopierten Code an der entsprechenden Stelle auf Ihrer Website ein. Normalerweise müssen Sie die Widget-Komponente zu Ihrer Hauptlayout-Datei oder Root-Komponente hinzufügen. Der Code lädt das Widget automatisch.",
    integrationStep5: "Ihr Widget ist jetzt einsatzbereit!",
    integrationStep5Desc: "Nach dem Hinzufügen des Codes aktualisieren Sie Ihre Website. Die Widget-Schaltfläche wird am unteren Rand Ihrer Seite angezeigt. Benutzer können auf diese Schaltfläche klicken, um Feedback zu senden.\n\nHinweis: Ihre Tenant ID wurde automatisch in den Integrationscode eingebettet. Diese ID bestimmt, an welches Projekt das Feedback gesendet wird. Sie können Ihre Tenant ID im Widget-Integrationscode einsehen.",
    previous: "Zurück",
    next: "Weiter",
    purchaseLicense: "Lizenz kaufen",
    // Public Portal
    publicPortal: "Öffentliches Portal",
    feedbackNav: "Feedback",
    roadmapNav: "Roadmap",
    changelogNav: "Änderungsprotokoll",
    feedbackTitle: "💬 Feedback",
    feedbackDescription: "Teilen Sie Ihr Feedback und Ihre Ideen",
    submitFeedback: "Feedback senden",
    submitYourFeedback: "Ihr Feedback senden",
    helpUsImprove:
      "Helfen Sie uns, uns zu verbessern, indem Sie Ihre Ideen und Vorschläge teilen",
    feedbackType: "Feedback-Typ",
    featureRequest: "Funktionsanfrage",
    bugReport: "Fehlerbericht",
    improvement: "Verbesserung",
    other: "Andere",
    title: "Titel",
    briefDescription: "Kurze Beschreibung Ihres Feedbacks",
    description: "Beschreibung",
    provideMoreDetails: "Geben Sie weitere Details zu Ihrem Feedback an...",
    yourName: "Ihr Name",
    yourEmail: "Ihre E-Mail",
    feedbackSubmittedSuccess:
      "Feedback erfolgreich gesendet! Es wird nach Überprüfung sichtbar sein.",
    projectNotFound: "Projekt nicht gefunden",
    projectNotFoundDescription: "Das gesuchte Projekt existiert nicht",
    projectNotFoundText:
      "Das Projekt, auf das Sie zugreifen möchten, existiert nicht oder wurde noch nicht eingerichtet.",
    contactAdministrator:
      "Bitte kontaktieren Sie den Administrator und versuchen Sie dann erneut, auf die öffentliche Seite zuzugreifen.",
    all: "Alle",
    backlog: "Warteschlange",
    planned: "Geplant",
    inDevelopment: "In Entwicklung",
    testing: "Testen",
    completed: "Abgeschlossen",
    new: "Neu",
    underReview: "In Überprüfung",
    inProgress: "In Bearbeitung",
    mostVoted: "Am meisten gewählt",
    newestFirst: "Neueste zuerst",
    oldestFirst: "Älteste zuerst",
    noFeedbackYet: "Noch kein Feedback",
    beFirstToShare: "Seien Sie der Erste, der seine Gedanken teilt!",
    views: "Aufrufe",
    by: "von",
    voteSaved: "Ihre Stimme wurde gespeichert!",
    voteRemoved: "Stimme entfernt",
    failedToVote: "Abstimmung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    failedToLoadFeedback: "Feedback konnte nicht geladen werden",
    loading: "Laden...",
    productRoadmap: "Produkt-Roadmap",
    seeWhatWeWorkingOn:
      "Sehen Sie, woran wir arbeiten und was als Nächstes kommt",
    noRoadmapItemsYet: "Noch keine Roadmap-Elemente",
    items: "Elemente",
    loadingRoadmap: "Roadmap wird geladen...",
    failedToLoadRoadmap: "Roadmap konnte nicht geladen werden",
    changelog: "Änderungsprotokoll",
    stayUpdated:
      "Bleiben Sie auf dem Laufenden mit unseren neuesten Versionen und Verbesserungen",
    noReleasesYet: "Noch keine Versionen",
    checkBackSoon: "Schauen Sie bald wieder vorbei für Updates",
    loadingChangelog: "Änderungsprotokoll wird geladen...",
    failedToLoadChangelog: "Änderungsprotokoll konnte nicht geladen werden",
    boardNotFound: "Board nicht gefunden",
    boardNotFoundDescription: "Das gesuchte Board existiert nicht",
    boardNotFoundText:
      "Das Board, auf das Sie zugreifen möchten, existiert nicht oder wurde noch nicht eingerichtet.",
    contactAdminToSetup:
      "Bitte kontaktieren Sie den Administrator, um ein Board einzurichten, und versuchen Sie dann erneut, auf die öffentliche Seite zuzugreifen.",
    selectCategory: "Eine Kategorie auswählen",
    category: "Kategorie",
    poweredBy: "Unterstützt von",
    footerCopyright: `© ${new Date().getFullYear()} Erstellt von ZeuZ IT`,
    privacyPolicy: "Datenschutzerklärung",
    legalNotice: "Rechtliche Hinweise",
    // Inactive Project Modal
    inactiveProjectTitle: "⚠️ Inaktives Projekt",
    inactiveProjectMessage: "Dieses Projekt ist nicht aktiv. Sie können keine Integrationen verwenden oder das Widget für dieses Projekt initialisieren.",
    inactiveProjectExplanation: "Um dieses Projekt zu aktivieren, gehen Sie zu Planverwaltung → Aktive Projekte und aktivieren Sie es.",
    activate: "Aktivieren & Öffnen",
    activatingProject: "Wird aktiviert...",
    goToPlanManagement: "Alle verwalten",
    cancel: "Abbrechen",
    maxActiveProjectsReached: "Maximale Anzahl aktiver Projekte erreicht",
    activationFailed: "Aktivierung fehlgeschlagen",
    projectActivated: "Projekt erfolgreich aktiviert",
    projectDeactivated: "Projekt erfolgreich deaktiviert",
    // Pending Plan Change Modal
    pendingDowngradeTitle: "Planänderung Ausstehend",
    pendingDowngradeMessage: "Ihre Änderung zum {plan} Plan ist für {date} geplant. Bitte warten Sie, bis der Vorgang abgeschlossen ist.",
    ok: "OK",
  },
  es: {
    dashboard: "Dashboard",
    feedback: "Comentarios",
    roadmap: "Hoja de Ruta",
    changelog: "Registro de Cambios",
    widget: "Integraciones",
    users: "Usuarios",
    contact: "Contacto",
    planManagement: "Gestión de Planes",
    settings: "Configuración",
    upgrade: "Mejorar",
    language: "Idioma",
    activeProject: "Proyecto Activo",
    addProject: "Agregar Proyecto",
    addProjectMobile: "Agregar",
    logout: "Cerrar Sesión",
    exitMobile: "Salir",
    purchaseNow: "Comprar ahora",
    createNewProject: "Crear Nuevo Proyecto",
    addNewProject: "Agregue un nuevo proyecto para organizar sus comentarios",
    projectName: "Nombre del Proyecto",
    projectNamePlaceholder: "Ej: Mi aplicación web",
    domain: "Dominio (Opcional)",
    domainPlaceholder: "example.com o *.example.com",
    domainHint: "Puede agregar o cambiar dominios más tarde en la configuración del Widget",
    invalidDomainFormat: "Formato de dominio inválido. Ejemplo: example.com o *.example.com",
    createProject: "Crear Proyecto",
    // Login & Register
    welcomeBack: "Bienvenido de nuevo",
    signInToContinue: "Inicia sesión en tu cuenta para continuar",
    emailLabel: "Correo Electrónico",
    emailPlaceholder: "tu@empresa.com",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "••••••••",
    forgotPassword: "¿Olvidaste tu contraseña?",
    signIn: "Iniciar Sesión",
    signingIn: "Iniciando sesión...",
    dontHaveAccount: "¿No tienes una cuenta?",
    signUp: "Regístrate",
    createAccount: "Crear cuenta",
    getStarted: "Comienza con tu cuenta gratuita",
    companyName: "Nombre de la Empresa",
    companyNamePlaceholder: "Acme S.L.",
    passwordRequirements: "Requisitos de Contraseña",
    minLength: "Al menos 8 caracteres",
    hasUpperCase: "Al menos una letra mayúscula",
    hasLowerCase: "Al menos una letra minúscula",
    hasNumber: "Al menos un número",
    hasSpecialChar: "Al menos un carácter especial",
    acceptTermsAndPrivacy: "Acepto los Términos de Servicio y la Política de Privacidad.",
    termsAndPrivacyRequired: "Debe aceptar los Términos de Servicio y la Política de Privacidad.",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    creatingAccount: "Creando cuenta...",
    incorrectEmailOrPassword: "Correo electrónico o contraseña incorrectos",
    emailNotRegistered: "Esta dirección de correo no está registrada en el sistema",
    incorrectPassword: "La contraseña es incorrecta, por favor intente de nuevo",
    emailNotFound: "No se encontró ninguna cuenta con esta dirección de correo",
    invalidEmailFormat: "Por favor, ingrese una dirección de correo electrónico válida",
    passwordRequirementsNotMet: "Por favor, cumpla con los requisitos de contraseña",
    registrationFailed: "Error en el registro",
    registrationSuccessful: "¡Registro exitoso!",
    loginSuccess: "¡Inicio de sesión exitoso!",
    emailAlreadyRegistered: "Esta dirección de correo electrónico ya está registrada",
    backendConnectionError: "No se puede conectar al servidor backend. Por favor, asegúrese de que el backend esté en ejecución.",
    // Google OAuth
    orContinueWith: "O continuar con",
    googleSignIn: "Iniciar sesión con Google",
    googleSignUp: "Registrarse con Google",
    googleLoginError: "Error al iniciar sesión con Google. Por favor, inténtelo de nuevo.",
    signingInWithGoogle: "Iniciando sesión con Google...",
    // Email Verification
    verificationEmailSent: "¡Registro exitoso! Por favor, verifique su dirección de correo electrónico.",
    verifying: "Verificando...",
    emailVerified: "Correo Electrónico Verificado",
    emailNotVerified: "Su dirección de correo electrónico no está verificada. Por favor, revise su correo electrónico y verifique su cuenta.",
    emailVerificationRequired: "Se requiere verificación de correo electrónico. Por favor, revise su correo electrónico y haga clic en el enlace de verificación.",
    verificationError: "Error de Verificación",
    verificationSuccess: "Su dirección de correo electrónico ha sido verificada exitosamente. Por favor, inicie sesión.",
    verificationInProgress: "Por favor, espere...",
    redirectingToLogin: "Será redirigido a la página de inicio de sesión...",
    verificationFailed: "La verificación falló. Por favor, intente crear una nueva cuenta o póngase en contacto con el soporte.",
    registerAgain: "Registrarse de Nuevo",
    invalidOrExpiredToken: "El token de verificación es inválido o ha expirado",
    // Password Reset
    resetPasswordTitle: "Restablecer Contraseña",
    resetPassword: "Restablecer Contraseña",
    resettingPassword: "Restableciendo contraseña...",
    newPassword: "Nueva Contraseña",
    confirmPassword: "Confirmar Contraseña",
    passwordResetSuccess: "Su contraseña ha sido restablecida exitosamente. Por favor, inicie sesión.",
    passwordResetError: "Error al Restablecer Contraseña",
    passwordResetFailed: "Error en el restablecimiento de contraseña.",
    requestNewLink: "Solicitar Nuevo Enlace",
    enterNewPassword: "Ingrese su nueva contraseña",
    // Forgot Password
    forgotPasswordTitle: "Olvidé mi Contraseña",
    forgotPasswordDescription: "Ingrese su dirección de correo electrónico y le enviaremos un enlace para restablecer su contraseña",
    checkYourEmail: "Revise su correo electrónico",
    passwordResetLinkSent: "¡Se ha enviado un enlace para restablecer la contraseña a su correo electrónico!",
    passwordResetLinkSentTo: "Se ha enviado un enlace para restablecer la contraseña a",
    checkEmailInbox: "Por favor, revise su bandeja de entrada. Si no ve el correo electrónico, revise su carpeta de spam.",
    sendNewEmail: "Enviar Nuevo Correo",
    sending: "Enviando...",
    sendPasswordResetLink: "Enviar Enlace de Restablecimiento de Contraseña",
    backToSignIn: "Volver a Iniciar Sesión",
    errorOccurred: "Ocurrió un error. Por favor, inténtelo de nuevo.",
    contactTitle: "Contacto",
    contactDescription: "Póngase en contacto con nosotros",
    sendMessage: "Enviar Mensaje",
    contactDescriptionText: "Contáctenos para sus preguntas o sugerencias",
    contactModalTitle: "Contáctenos sobre el plan Enterprise",
    contactModalDescription: "Envíe su solicitud y le responderemos lo antes posible. Se utilizan los mismos ajustes SMTP que el formulario de contacto de la landing.",
    yourName: "Su Nombre",
    email: "Correo Electrónico",
    subject: "Asunto",
    message: "Su Mensaje",
    messagePlaceholder: "Escriba su mensaje aquí...",
    subjectPlaceholder: "Asunto del mensaje",
    sending: "Enviando...",
    messageSent: "¡Su mensaje ha sido enviado con éxito!",
    messageFailed:
      "No se pudo enviar el mensaje. Por favor, inténtelo de nuevo.",
    allFieldsRequired: "Por favor complete todos los campos",
    pleaseFillThisField: "Por favor complete este campo",
    projectCreated: "¡Proyecto creado con éxito!",
    projectCreateFailed: "No se pudo crear el proyecto",
    // Team/Users
    usersTitle: "Usuarios",
    usersDescription: "usuarios del proyecto que han enviado comentarios",
    usersDescriptionNoProject:
      "Usuarios que han enviado comentarios al proyecto",
    noUsersYet: "Aún no hay usuarios",
    noUsersDescription:
      "Los usuarios que envíen comentarios al proyecto aparecerán aquí",
    anonymous: "Anónimo",
    feedbacks: "Comentarios",
    lastActivity: "Última Actividad",
    userActivityHistory: "Historial de actividad del usuario",
    submittedFeedbacks: "Comentarios Enviados",
    noFeedbacksYet: "Este usuario aún no ha enviado ningún comentario",
    loading: "Cargando...",
    type: "Tipo",
    status: "Estado",
    // Widget
    widgetIntegration: "Integración de Widget",
    widgetDescription:
      "Agregue y personalice el widget de comentarios a su sitio web",
    customize: "Personalizar",
    integrationCode: "Código de Integración",
    widgetSettings: "Configuración del Widget",
    widgetSettingsDescription:
      "Personalice la apariencia y el comportamiento del widget",
    buttonColor: "Color del Botón",
    backgroundColor: "Color de Fondo",
    buttonStyle: "Estilo del Botón",
    rounded: "Redondo",
    roundedLarge: "Esquinas Redondeadas",
    roundedSmall: "Ligeramente Redondeado",
    roundedNone: "Cuadrado",
    fontFamily: "Familia de Fuentes",
    fontSize: "Tamaño de Fuente",
    small: "Pequeño",
    medium: "Mediano",
    large: "Grande",
    veryLarge: "Muy Grande",
    theme: "Tema",
    darkMode: "Modo Oscuro",
    lightMode: "Modo Claro",
    buttonPosition: "Posición del Botón (Opcional)",
    buttonPositionPlaceholder: "#blog-footer o .feedback-section",
    buttonPositionDescription:
      "Si se deja vacío, aparece en la parte inferior central de la página. Ingrese un selector CSS (ej: #container-id o .class-name)",
    save: "Guardar",
    livePreview: "Vista Previa en Vivo",
    livePreviewDescription: "Vea cómo aparecerá el widget en su sitio web",
    websiteContent: "El contenido de su sitio web aparecerá aquí",
    feedback: "Comentario",
    featureRequest: "Solicitud de Función",
    bug: "Error",
    other: "Otro",
    roadmap: "Hoja de Ruta",
    changelog: "Registro de Cambios",
    title: "Título",
    titlePlaceholder: "Breve descripción de su comentario",
    description: "Descripción",
    descriptionPlaceholder: "Proporcione más detalles sobre su comentario...",
    yourName: "Su Nombre",
    yourNamePlaceholder: "Juan Pérez",
    yourEmail: "Su Correo",
    yourEmailPlaceholder: "juan@ejemplo.com",
    submitFeedback: "Enviar Comentario",
    feedbackSubmitted: "¡Comentario enviado! (Modo de vista previa)",
    activeProjectNotFound:
      "Proyecto activo no encontrado. Por favor, seleccione un proyecto primero.",
    selectFramework: "Seleccionar Framework / Plataforma",
    reactCode: "Código del Componente React",
    vueCode: "Código del Componente Vue",
    nuxtCode: "Código del Plugin Nuxt",
    nextCode: "Código del Componente Next.js",
    wordpressCode: "Código PHP de WordPress",
    generalGuide: "Guía General de Integración",
    copyCode: "Copiar Código",
    copyContent: "Copiar Contenido",
    copied: "¡Copiado!",
    installationInstructions: "Instrucciones de Instalación",
    changesSaved: "Cambios Guardados",
    changesSavedDescription:
      "La configuración de su widget se ha guardado exitosamente. Haga clic en el botón a continuación para obtener el código de integración.",
    close: "Cerrar",
    getIntegrationCode: "Obtener Código de Integración",
    widgetUsage: "Uso:",
    widgetUsageVue: "Uso (App.vue o componente padre):",
    widgetUsageNext: "Uso (app.tsx o page.tsx):",
    widgetNuxtPluginComment1: "// plugins/feedback-widget.client.js",
    widgetNuxtPluginComment2: "// Este plugin inicializa automáticamente todas las páginas",
    widgetNuxtPluginComment3: "// Configurado con tenantId: {tenantId}",
    widgetWpUrlComment: "// URL del Widget - siempre cargado desde feedpanels.com",
    widgetOtherScriptComment: "<!-- Cargar script del Widget -->",
    // Installation instructions by framework
    reactInstall1: "Copie el código del componente arriba",
    reactInstall2:
      "Agregue el componente a un lugar apropiado en su proyecto (ej: App.js o componente Layout)",
    reactInstall3: "Importe y renderice el componente:",
    reactInstall4: "Guarde los cambios y actualice su aplicación",
    reactInstall5:
      "Verifique que el botón del widget aparezca cuando el componente se renderiza",
    vueInstall1: "Copie el código del componente arriba",
    vueInstall2: "Agregue el componente a la carpeta components en su proyecto",
    vueInstall3: "Importe y úselo en la página donde desea usarlo",
    vueInstall4: "Guarde los cambios y actualice su aplicación",
    vueInstall5:
      "Verifique que el botón del widget aparezca cuando el componente se monta",
    nuxtInstall1: "Copie el código del plugin arriba",
    nuxtInstall2: "Guarde el código en",
    nuxtInstall3: "archivo",
    nuxtInstall4: "Nuxt cargará el plugin automáticamente",
    nuxtInstall5: "Reinicie su aplicación",
    nuxtInstall6:
      "Verifique que el botón del widget aparezca cuando la página se carga",
    nextInstall1: "Copie el código del componente arriba",
    nextInstall2: "Guarde el componente en",
    nextInstall3: "archivo",
    nextInstall4: "Importe el componente en su archivo de layout o página:",
    nextInstall5: "Guarde los cambios y actualice su aplicación",
    nextInstall6:
      "Verifique que el botón del widget aparezca cuando la página se renderiza",
    wordpressInstall1: "Copie el código PHP arriba",
    wordpressInstall2:
      "Inicie sesión en el panel de administración de WordPress",
    wordpressInstall3:
      "Vaya a Apariencia → Editor de Temas → Abra el archivo functions.php",
    wordpressInstall4: "Agregue el código al final del archivo functions.php",
    wordpressInstall5: "Guarde el archivo",
    wordpressInstall6:
      "Verifique que el botón del widget aparezca cuando actualice la página",
    wordpressCodeComment: "WordPress: Agregar a su archivo functions.php",
    // Other framework guide
    otherUsage: "Uso en cualquier sitio web",
    otherInstallation: "Instalación",
    otherInstallationDescription:
      "Agregue esta única etiqueta de script para habilitar todas las funciones de incrustación de FeedbackFlow:",
    otherFeature1: "Característica 1: Herramienta de Comentarios",
    otherFeature1Description: "Recopile comentarios de sus usuarios.",
    otherFeature1Details:
      'El widget muestra automáticamente un botón "Solicitud de Función" en la parte inferior central de la página. Cuando se hace clic en el botón, se abre un modal de comentarios y los usuarios pueden seleccionar uno de los siguientes tipos de comentarios:',
    otherFeature1Item1: "- Solicitud de Función",
    otherFeature1Item2: "- Reporte de Error",
    otherFeature1Item3: "- Otro",
    otherFeature1Item4: "",
    otherFeature2: "Característica 2: Widget de Hoja de Ruta",
    otherFeature2Description:
      'Use el botón "Hoja de Ruta" dentro del modal para ver su hoja de ruta. Este botón abre su página pública de hoja de ruta en una nueva pestaña.',
    otherFeature3: "Característica 3: Widget de Registro de Cambios",
    otherFeature3Description:
      'Use el botón "Registro de Cambios" dentro del modal para ver las actualizaciones recientes. Este botón abre su página pública de registro de cambios en una nueva pestaña.',
    otherCustomization: "Personalización",
    otherCustomizationDescription:
      "Puede personalizar la apariencia del widget cambiando los parámetros en la función init:",
    otherParam1: "- tenantId: Identificador único de su proyecto",
    otherParam2:
      '- primaryColor: Color del botón (en formato hex, ej: "#0891b2")',
    otherParam3:
      '- backgroundColor: Color de fondo del modal (en formato hex, ej: "#ffffff")',
    otherParam4:
      '- buttonStyle: Estilo del botón ("rounded-full", "rounded-lg", "rounded", "rounded-none")',
    otherParam5: '- fontSize: Tamaño de fuente (ej: "16px")',
    otherParam6: '- fontFamily: Familia de fuentes (ej: "Inter, sans-serif")',
    otherParam7: '- theme: Tema ("light" o "dark")',
    otherExample: "Ejemplo de Uso",
    otherExampleBasic: "Configuración básica:",
    otherNote:
      "Nota: Agregue el widget justo antes de la etiqueta </body> de su sitio web. El widget se cargará automáticamente y aparecerá en la parte inferior central de la página.",
    // Changelog
    changelogTitle: "Registro de Cambios",
    changelogDescription:
      "Mantenga a sus usuarios informados sobre las actualizaciones",
    viewPublicChangelog: "Ver Registro de Cambios Público",
    newRelease: "Nueva Versión",
    createChangelogEntry: "Crear Entrada de Registro de Cambios",
    createChangelogDescription: "Documente su última versión o actualización",
    version: "Versión",
    versionPlaceholder: "v2.1.0",
    title: "Título",
    titlePlaceholder: "Integración de Slack y Mejoras de Rendimiento",
    content: "Contenido",
    contentPlaceholder:
      "Nuevas Características:\n- Integración de Slack\n- Modo oscuro\n\nCorrecciones de Errores:\n- Notificaciones por correo corregidas",
    publishChangelog: "Publicar Registro de Cambios",
    loadingChangelog: "Cargando registro de cambios...",
    noChangelogEntries: "Aún no hay entradas en el registro de cambios",
    createFirstReleaseNote: "Cree su primera nota de versión",
    deleteChangelogEntry: "Eliminar Entrada de Registro de Cambios",
    deleteChangelogConfirm:
      "¿Está seguro de que desea eliminar esta entrada del registro de cambios?",
    deleteChangelogWarning:
      "Esta acción no se puede deshacer y el registro de cambios se eliminará tanto del panel de administración como del portal público.",
    cancel: "Cancelar",
    delete: "Eliminar",
    changelogCreated: "Registro de cambios creado",
    changelogCreateFailed: "Error al crear el registro de cambios",
    changelogDeleted: "Registro de cambios eliminado con éxito",
    changelogDeleteFailed: "Error al eliminar el registro de cambios",
    changelogLoadFailed: "Error al cargar los registros de cambios",
    pleaseSelectProject: "Por favor, seleccione un proyecto primero",
    // Roadmap
    productRoadmap: "Hoja de Ruta del Producto",
    roadmapDescription:
      "Planifique y rastree las características de su producto",
    newItem: "Nuevo Elemento",
    createRoadmapItem: "Crear Elemento de Hoja de Ruta",
    createRoadmapDescription:
      "Agregue una nueva característica o iniciativa a su hoja de ruta",
    roadmapTitle: "Título",
    roadmapTitlePlaceholder: "Integración de Slack",
    roadmapDescriptionLabel: "Descripción",
    roadmapDescriptionPlaceholder: "Integrar con Slack para notificaciones...",
    quarter: "Trimestre",
    quarterPlaceholder: "Q2 2025",
    status: "Estado",
    createItem: "Crear Elemento",
    loadingRoadmap: "Cargando hoja de ruta...",
    noRoadmapItems: "Aún no hay elementos en la hoja de ruta",
    items: "elementos",
    fromFeedback: "De Comentarios",
    votes: "votos",
    statusUpdated: "Estado actualizado con éxito",
    statusUpdateFailed: "Error al actualizar el estado",
    roadmapItemCreated: "Elemento de hoja de ruta creado",
    roadmapItemCreateFailed: "Error al crear el elemento",
    roadmapLoadFailed: "Error al cargar la hoja de ruta",
    roadmapItemDeleted: "Elemento de hoja de ruta eliminado. También se ha eliminado del panel público.",
    roadmapItemDeleteFailed: "Error al eliminar el elemento de la hoja de ruta",
    deleteRoadmapItem: "Eliminar elemento de la hoja de ruta",
    deleteRoadmapItemConfirm: "¿Está seguro de que desea eliminar este elemento? También se eliminará de la hoja de ruta pública.",
    roadmapItemFromFeedbackCannotDelete: "Este elemento proviene de un comentario. Solo puede eliminarlo desde el panel de Comentarios.",
    // Roadmap Status Labels
    backlog: "Pendiente",
    planned: "Planificado",
    inDevelopment: "En Desarrollo",
    testing: "En Pruebas",
    completed: "Completado",
    // Feedback
    feedbackTitle: "Comentarios",
    feedbackDescription:
      "Gestione los comentarios y solicitudes de los clientes",
    loadingFeedback: "Cargando comentarios...",
    noFeedbackYet: "Aún no hay comentarios",
    noFeedbackDescription:
      "Los usuarios pueden enviar comentarios a través del portal público",
    loading: "Cargando...",
    submittedBy: "Enviado por",
    anonymous: "Anónimo",
    description: "Descripción",
    updateStatus: "Actualizar Estado",
    upvotes: "Votos",
    views: "Visualizaciones",
    deleteFeedback: "Eliminar Comentario",
    deleteFeedbackConfirm:
      "¿Está seguro de que desea eliminar este comentario?",
    deleteFeedbackWarning:
      "Esta acción no se puede deshacer. El comentario se eliminará de:",
    adminPanel: "Panel de administración",
    publicPortal: "Portal público",
    roadmap: "Hoja de ruta",
    allRelatedVotes: "Todos los votos relacionados",
    cancel: "Cancelar",
    delete: "Eliminar",
    feedbackDeleted: "Comentario eliminado con éxito",
    feedbackDeleteFailed: "Error al eliminar el comentario",
    feedbackLoadFailed: "Error al cargar los comentarios",
    voteFailed: "Error al votar",
    statusUpdated: "Estado actualizado",
    statusUpdateFailed: "Error al actualizar el estado",
    // Feedback Type Labels
    feature: "Característica",
    bug: "Error",
    improvement: "Mejora",
    other: "Otro",
    // Priority Labels
    low: "Bajo",
    medium: "Medio",
    high: "Alto",
    urgent: "Urgente",
    // Comments
    comments: "Comentarios",
    comment: "Comentario",
    writeComment: "Escribe tu comentario...",
    submitComment: "Enviar Comentario",
    commentSubmitted: "Comentario enviado",
    commentSubmitFailed: "Error al enviar comentario",
    commentRequired: "El comentario no puede estar vacío",
    commentsLoadFailed: "Error al cargar comentarios",
    failedToLoadComments: "Error al cargar comentarios",
    failedToSubmitComment: "Error al enviar comentario",
    noCommentsYet: "Aún no hay comentarios. ¡Sé el primero en comentar!",
    reply: "Responder",
    writeReply: "Escribe tu respuesta...",
    sendReply: "Enviar Respuesta",
    replySubmitted: "Respuesta enviada",
    replySubmitFailed: "Error al enviar respuesta",
    cancelReply: "Cancelar",
    internal: "Interno",
    public: "Público",
    projectSettings: "Configuración del Proyecto",
    enableComments: "Habilitar Comentarios",
    enableCommentsDescription:
      "Permitir que los usuarios comenten en los comentarios",
    commentsEnabled: "Comentarios habilitados",
    commentsDisabled: "Comentarios deshabilitados",
    settingsUpdateFailed: "Error al actualizar la configuración",
    unsavedChangesTitle: "Cambios Sin Guardar",
    unsavedChangesMessage:
      "Tienes cambios sin guardar en tu configuración de personalización. Si procedes al código de integración, estos cambios se perderán y el código será diferente de tu configuración actual.",
    continueAnyway: "Continuar de Todos Modos",
    // Dashboard
    welcomeBack: "¡Bienvenido de nuevo! 👋",
    dashboardIntro: "Esto es lo que está pasando con sus comentarios:",
    totalFeedback: "Total de Comentarios",
    allTime: "Todo el tiempo",
    activeFeedback: "Comentarios Activos",
    inProgress: "En progreso",
    thisMonth: "Este Mes",
    newSubmissions: "Nuevas entregas",
    topFeedback: "Mejores Comentarios",
    noFeedbackYet: "Aún no hay comentarios",
    yourProjects: "Sus Proyectos",
    active: "Activo",
    created: "Creado",
    quickActions: "Acciones rápidas",
    viewAllFeedback: "Ver todos los comentarios",
    manageRoadmap: "Gestionar hoja de ruta",
    setupWidget: "Configurar widget",
    publicPages: "Páginas públicas",
    publicFeedback: "Comentarios públicos",
    publicRoadmap: "Hoja de ruta pública",
    publicChangelog: "Registro de cambios público",
    selectProjectToViewPublicPages:
      "Seleccione un proyecto para ver las páginas públicas",
    ipAddress: "Dirección IP",
    daysRemaining: "Días restantes",
    status: "Estado",
    statsLoadFailed: "Error al cargar las estadísticas",
    welcomeToFeedbackFlow: "¡Bienvenido a FeedbackFlow! 🎉",
    firstProjectModalDescription:
      "Cree su primer proyecto para empezar. Un nombre de proyecto le ayuda a organizar sus comentarios.",
    moreProjectsHint: "💡 Puede añadir más proyectos en cualquier momento",
    createProject: "Crear proyecto",
    creatingProject: "Creando...",
    projectNamePlaceholder: "Ej: Mi aplicación web",
    pleaseEnterProjectName: "Por favor, ingrese el nombre del proyecto",
    projectCreatedWelcome: "¡Proyecto creado! ¡Bienvenido a FeedbackFlow!",
    howToIntegrateButton: "¿Cómo integrar?",
    integrationGuideTitle: "Guía de Integración",
    integrationPreStep: "Antes de comenzar",
    integrationPreStepDesc: "Antes de comenzar, cree su proyecto y no olvide asignar un nombre de dominio al proyecto que ha creado. Si su proyecto y dominio ya están creados, asegúrese de que el proyecto que desea integrar esté seleccionado como proyecto activo.",
    integrationStep1: "Vaya a la pestaña 'Integración' desde el menú del Dashboard",
    integrationStep1Desc: "Haga clic en la pestaña 'Integración' o 'Widget' del menú izquierdo para acceder a la página de integración. Aquí puede personalizar su widget y obtener el código de integración.",
    integrationStep2: "Personalice la configuración de su widget (color, posición, estilo, etc.)",
    integrationStep2Desc: "Personalice la apariencia de su widget para que coincida con su marca. Puede cambiar configuraciones como color, estilo del botón, familia de fuentes y tamaño. Haga clic en el botón 'Guardar' para guardar sus cambios.",
    integrationStep3: "Copie el código de integración para su framework",
    integrationStep3Desc: "Vaya a la pestaña 'Código de Integración' y seleccione su framework (React, Vue, Next.js, WordPress, etc.). Copie el código preparado para su framework seleccionado.",
    integrationStep4: "Agregue el código al lugar apropiado en su sitio web",
    integrationStep4Desc: "Pegue el código copiado en el lugar apropiado en su sitio web. Por lo general, necesita agregar el componente del widget a su archivo de diseño principal o componente raíz. El código cargará el widget automáticamente.",
    integrationStep5: "¡Su widget ahora está listo para usar!",
    integrationStep5Desc: "Después de agregar el código, actualice su sitio web. El botón del widget aparecerá en la parte inferior de su página. Los usuarios pueden hacer clic en este botón para enviar comentarios.\n\nNota: Su ID de Tenant se ha incrustado automáticamente en el código de integración. Este ID determina a qué proyecto se enviará el comentario. Puede ver su ID de Tenant en el código de integración del widget.",
    previous: "Anterior",
    next: "Siguiente",
    purchaseLicense: "Comprar Licencia",
    // Public Portal
    publicPortal: "Portal Público",
    feedbackNav: "Comentarios",
    roadmapNav: "Hoja de Ruta",
    changelogNav: "Registro de Cambios",
    feedbackTitle: "💬 Comentarios",
    feedbackDescription: "Comparte tus comentarios e ideas",
    submitFeedback: "Enviar Comentario",
    submitYourFeedback: "Envía tu Comentario",
    helpUsImprove: "Ayúdanos a mejorar compartiendo tus ideas y sugerencias",
    feedbackType: "Tipo de Comentario",
    featureRequest: "Solicitud de Función",
    bugReport: "Reporte de Error",
    improvement: "Mejora",
    other: "Otro",
    title: "Título",
    briefDescription: "Breve descripción de tu comentario",
    description: "Descripción",
    provideMoreDetails: "Proporciona más detalles sobre tu comentario...",
    yourName: "Tu Nombre",
    yourEmail: "Tu Correo Electrónico",
    feedbackSubmittedSuccess:
      "¡Comentario enviado con éxito! Será visible después de la revisión.",
    projectNotFound: "Proyecto No Encontrado",
    projectNotFoundDescription: "El proyecto que buscas no existe",
    projectNotFoundText:
      "El proyecto al que intentas acceder no existe o aún no ha sido configurado.",
    contactAdministrator:
      "Por favor, contacta al administrador y luego intenta acceder a la página pública nuevamente.",
    all: "Todos",
    backlog: "Pendiente",
    planned: "Planificado",
    inDevelopment: "En Desarrollo",
    testing: "Pruebas",
    completed: "Completado",
    new: "Nuevo",
    underReview: "En Revisión",
    inProgress: "En Progreso",
    mostVoted: "Más Votados",
    newestFirst: "Más Recientes Primero",
    oldestFirst: "Más Antiguos Primero",
    noFeedbackYet: "Aún no hay comentarios",
    beFirstToShare: "¡Sé el primero en compartir tus pensamientos!",
    views: "visualizaciones",
    by: "por",
    voteSaved: "¡Tu voto ha sido guardado!",
    voteRemoved: "Voto eliminado",
    failedToVote: "Error al votar. Por favor, intenta de nuevo.",
    failedToLoadFeedback: "Error al cargar comentarios",
    loading: "Cargando...",
    productRoadmap: "Hoja de Ruta del Producto",
    seeWhatWeWorkingOn: "Ve en qué estamos trabajando y qué viene después",
    noRoadmapItemsYet: "Aún no hay elementos en la hoja de ruta",
    items: "elementos",
    loadingRoadmap: "Cargando hoja de ruta...",
    failedToLoadRoadmap: "Error al cargar la hoja de ruta",
    changelog: "Registro de Cambios",
    stayUpdated:
      "Mantente actualizado con nuestros últimos lanzamientos y mejoras",
    noReleasesYet: "Aún no hay lanzamientos",
    checkBackSoon: "Vuelve pronto para ver actualizaciones",
    loadingChangelog: "Cargando registro de cambios...",
    failedToLoadChangelog: "Error al cargar el registro de cambios",
    boardNotFound: "Tablero No Encontrado",
    boardNotFoundDescription: "El tablero que buscas no existe",
    boardNotFoundText:
      "El tablero al que intentas acceder no existe o aún no ha sido configurado.",
    contactAdminToSetup:
      "Por favor, contacta al administrador para configurar un tablero, y luego intenta acceder a la página pública nuevamente.",
    selectCategory: "Selecciona una categoría",
    category: "Categoría",
    poweredBy: "Desarrollado por",
    footerCopyright: `© ${new Date().getFullYear()} Creado por ZeuZ IT`,
    privacyPolicy: "Política de Privacidad",
    legalNotice: "Aviso Legal",
    // Inactive Project Modal
    inactiveProjectTitle: "⚠️ Proyecto Inactivo",
    inactiveProjectMessage: "Este proyecto no está activo. No puedes usar integraciones ni inicializar el widget para este proyecto.",
    inactiveProjectExplanation: "Para activar este proyecto, ve a Gestión de Planes → Proyectos Activos y actívalo.",
    activate: "Activar y Abrir",
    activatingProject: "Activando...",
    goToPlanManagement: "Administrar Todos",
    cancel: "Cancelar",
    maxActiveProjectsReached: "Ha alcanzado el número máximo de proyectos activos",
    activationFailed: "Error al activar proyecto",
    projectActivated: "Proyecto activado exitosamente",
    projectDeactivated: "Proyecto desactivado exitosamente",
    // Pending Plan Change Modal
    pendingDowngradeTitle: "Cambio de Plan Pendiente",
    pendingDowngradeMessage: "Tu cambio al plan {plan} está programado para {date}. Por favor espera a que se complete el proceso.",
    ok: "Aceptar",
  },
  fr: {
    dashboard: "Tableau de Bord",
    feedback: "Commentaires",
    roadmap: "Feuille de Route",
    changelog: "Journal des Modifications",
    widget: "Intégrations",
    users: "Utilisateurs",
    contact: "Contact",
    planManagement: "Gestion des Plans",
    settings: "Paramètres",
    upgrade: "Améliorer",
    language: "Langue",
    activeProject: "Projet Actif",
    addProject: "Ajouter un Projet",
    addProjectMobile: "Ajouter",
    logout: "Déconnexion",
    exitMobile: "Quitter",
    purchaseNow: "Acheter maintenant",
    createNewProject: "Créer un Nouveau Projet",
    addNewProject: "Ajoutez un nouveau projet pour organiser vos commentaires",
    projectName: "Nom du Projet",
    projectNamePlaceholder: "Ex: Mon application web",
    domain: "Domaine (Optionnel)",
    domainPlaceholder: "example.com ou *.example.com",
    domainHint: "Vous pouvez ajouter ou modifier les domaines plus tard dans les paramètres du Widget",
    invalidDomainFormat: "Format de domaine invalide. Exemple: example.com ou *.example.com",
    createProject: "Créer le Projet",
    // Login & Register
    welcomeBack: "Bon retour",
    signInToContinue: "Connectez-vous à votre compte pour continuer",
    emailLabel: "E-mail",
    emailPlaceholder: "vous@entreprise.com",
    passwordLabel: "Mot de passe",
    passwordPlaceholder: "••••••••",
    forgotPassword: "Mot de passe oublié?",
    signIn: "Se connecter",
    signingIn: "Connexion en cours...",
    dontHaveAccount: "Vous n'avez pas de compte?",
    signUp: "S'inscrire",
    createAccount: "Créer un compte",
    getStarted: "Commencez avec votre compte gratuit",
    companyName: "Nom de l'Entreprise",
    companyNamePlaceholder: "Acme SARL",
    passwordRequirements: "Exigences du Mot de Passe",
    minLength: "Au moins 8 caractères",
    hasUpperCase: "Au moins une lettre majuscule",
    hasLowerCase: "Au moins une lettre minuscule",
    hasNumber: "Au moins un chiffre",
    hasSpecialChar: "Au moins un caractère spécial",
    acceptTermsAndPrivacy: "J'accepte les Conditions d'Utilisation et la Politique de Confidentialité.",
    termsAndPrivacyRequired: "Vous devez accepter les Conditions d'Utilisation et la Politique de Confidentialité.",
    alreadyHaveAccount: "Vous avez déjà un compte?",
    creatingAccount: "Création du compte...",
    incorrectEmailOrPassword: "E-mail ou mot de passe incorrect",
    emailNotRegistered: "Cette adresse e-mail n'est pas enregistrée dans le système",
    incorrectPassword: "Le mot de passe est incorrect, veuillez réessayer",
    emailNotFound: "Aucun compte trouvé avec cette adresse e-mail",
    invalidEmailFormat: "Veuillez entrer une adresse e-mail valide",
    passwordRequirementsNotMet: "Veuillez respecter les exigences du mot de passe",
    registrationFailed: "Échec de l'inscription",
    registrationSuccessful: "Inscription réussie !",
    loginSuccess: "Connexion réussie !",
    emailAlreadyRegistered: "Cette adresse e-mail est déjà enregistrée",
    backendConnectionError: "Impossible de se connecter au serveur backend. Veuillez vous assurer que le backend est en cours d'exécution.",
    // Google OAuth
    orContinueWith: "Ou continuer avec",
    googleSignIn: "Se connecter avec Google",
    googleSignUp: "S'inscrire avec Google",
    googleLoginError: "Échec de la connexion Google. Veuillez réessayer.",
    signingInWithGoogle: "Connexion avec Google...",
    // Email Verification
    verificationEmailSent: "Inscription réussie ! Veuillez vérifier votre adresse e-mail.",
    verifying: "Vérification en cours...",
    emailVerified: "E-mail Vérifié",
    emailNotVerified: "Votre adresse e-mail n'est pas vérifiée. Veuillez vérifier votre e-mail et vérifier votre compte.",
    emailVerificationRequired: "Vérification de l'e-mail requise. Veuillez vérifier votre e-mail et cliquer sur le lien de vérification.",
    verificationError: "Erreur de Vérification",
    verificationSuccess: "Votre adresse e-mail a été vérifiée avec succès. Veuillez vous connecter.",
    verificationInProgress: "Veuillez patienter...",
    redirectingToLogin: "Vous serez redirigé vers la page de connexion...",
    verificationFailed: "La vérification a échoué. Veuillez essayer de créer un nouveau compte ou contacter le support.",
    registerAgain: "S'inscrire à Nouveau",
    invalidOrExpiredToken: "Le jeton de vérification est invalide ou expiré",
    // Password Reset
    resetPasswordTitle: "Réinitialiser le Mot de Passe",
    resetPassword: "Réinitialiser le Mot de Passe",
    resettingPassword: "Réinitialisation du mot de passe...",
    newPassword: "Nouveau Mot de Passe",
    confirmPassword: "Confirmer le Mot de Passe",
    passwordResetSuccess: "Votre mot de passe a été réinitialisé avec succès. Veuillez vous connecter.",
    passwordResetError: "Erreur de Réinitialisation du Mot de Passe",
    passwordResetFailed: "Échec de la réinitialisation du mot de passe.",
    requestNewLink: "Demander un Nouveau Lien",
    enterNewPassword: "Entrez votre nouveau mot de passe",
    // Forgot Password
    forgotPasswordTitle: "Mot de Passe Oublié",
    forgotPasswordDescription: "Entrez votre adresse e-mail et nous vous enverrons un lien de réinitialisation du mot de passe",
    checkYourEmail: "Vérifiez votre e-mail",
    passwordResetLinkSent: "Le lien de réinitialisation du mot de passe a été envoyé à votre e-mail !",
    passwordResetLinkSentTo: "Le lien de réinitialisation du mot de passe a été envoyé à",
    checkEmailInbox: "Veuillez vérifier votre boîte de réception. Si vous ne voyez pas l'e-mail, vérifiez votre dossier spam.",
    sendNewEmail: "Envoyer un Nouvel E-mail",
    sending: "Envoi en cours...",
    sendPasswordResetLink: "Envoyer le Lien de Réinitialisation",
    backToSignIn: "Retour à la Connexion",
    errorOccurred: "Une erreur s'est produite. Veuillez réessayer.",
    contactTitle: "Contact",
    contactDescription: "Contactez-nous",
    sendMessage: "Envoyer un Message",
    contactDescriptionText: "Contactez-nous pour vos questions ou suggestions",
    contactModalTitle: "Contactez-nous pour le plan Enterprise",
    contactModalDescription: "Envoyez votre demande et nous vous répondrons dans les plus brefs délais. Les mêmes paramètres SMTP que le formulaire de contact de la page d'accueil sont utilisés.",
    yourName: "Votre Nom",
    email: "E-mail",
    subject: "Sujet",
    message: "Votre Message",
    messagePlaceholder: "Écrivez votre message ici...",
    subjectPlaceholder: "Sujet du message",
    sending: "Envoi en cours...",
    messageSent: "Votre message a été envoyé avec succès !",
    messageFailed: "Échec de l'envoi du message. Veuillez réessayer.",
    allFieldsRequired: "Veuillez remplir tous les champs",
    pleaseFillThisField: "Veuillez remplir ce champ",
    projectCreated: "Projet créé avec succès !",
    projectCreateFailed: "Échec de la création du projet",
    // Team/Users
    usersTitle: "Utilisateurs",
    usersDescription: "utilisateurs du projet qui ont soumis des commentaires",
    usersDescriptionNoProject:
      "Utilisateurs qui ont soumis des commentaires au projet",
    noUsersYet: "Aucun utilisateur pour le moment",
    noUsersDescription:
      "Les utilisateurs qui soumettent des commentaires au projet apparaîtront ici",
    anonymous: "Anonyme",
    feedbacks: "Commentaires",
    lastActivity: "Dernière Activité",
    userActivityHistory: "Historique d'activité de l'utilisateur",
    submittedFeedbacks: "Commentaires Soumis",
    noFeedbacksYet: "Cet utilisateur n'a pas encore soumis de commentaire",
    loading: "Chargement...",
    type: "Type",
    status: "Statut",
    // Widget
    widgetIntegration: "Intégration de Widget",
    widgetDescription:
      "Ajoutez et personnalisez le widget de commentaires sur votre site web",
    customize: "Personnaliser",
    integrationCode: "Code d'Intégration",
    widgetSettings: "Paramètres du Widget",
    widgetSettingsDescription:
      "Personnalisez l'apparence et le comportement du widget",
    buttonColor: "Couleur du Bouton",
    backgroundColor: "Couleur de Fond",
    buttonStyle: "Style du Bouton",
    rounded: "Rond",
    roundedLarge: "Coins Arrondis",
    roundedSmall: "Légèrement Arrondi",
    roundedNone: "Carré",
    fontFamily: "Famille de Police",
    fontSize: "Taille de Police",
    small: "Petit",
    medium: "Moyen",
    large: "Grand",
    veryLarge: "Très Grand",
    theme: "Thème",
    darkMode: "Mode Sombre",
    lightMode: "Mode Clair",
    buttonPosition: "Position du Bouton (Optionnel)",
    buttonPositionPlaceholder: "#blog-footer ou .feedback-section",
    buttonPositionDescription:
      "Si laissé vide, apparaît au centre inférieur de la page. Entrez un sélecteur CSS (ex: #container-id ou .class-name)",
    save: "Enregistrer",
    livePreview: "Aperçu en Direct",
    livePreviewDescription:
      "Voyez comment le widget apparaîtra sur votre site web",
    websiteContent: "Le contenu de votre site web apparaîtra ici",
    feedback: "Commentaire",
    featureRequest: "Demande de Fonctionnalité",
    bug: "Bug",
    other: "Autre",
    roadmap: "Feuille de Route",
    changelog: "Journal des Modifications",
    title: "Titre",
    titlePlaceholder: "Brève description de votre commentaire",
    description: "Description",
    descriptionPlaceholder:
      "Fournissez plus de détails sur votre commentaire...",
    yourName: "Votre Nom",
    yourNamePlaceholder: "Jean Dupont",
    yourEmail: "Votre E-mail",
    yourEmailPlaceholder: "jean@exemple.com",
    submitFeedback: "Envoyer le Commentaire",
    feedbackSubmitted: "Commentaire envoyé ! (Mode aperçu)",
    activeProjectNotFound:
      "Projet actif introuvable. Veuillez d'abord sélectionner un projet.",
    selectFramework: "Sélectionner Framework / Plateforme",
    reactCode: "Code du Composant React",
    vueCode: "Code du Composant Vue",
    nuxtCode: "Code du Plugin Nuxt",
    nextCode: "Code du Composant Next.js",
    wordpressCode: "Code PHP WordPress",
    generalGuide: "Guide d'Intégration Général",
    copyCode: "Copier le Code",
    copyContent: "Copier le Contenu",
    copied: "Copié !",
    installationInstructions: "Instructions d'Installation",
    changesSaved: "Modifications Enregistrées",
    changesSavedDescription:
      "Vos paramètres de widget ont été enregistrés avec succès. Cliquez sur le bouton ci-dessous pour obtenir le code d'intégration.",
    close: "Fermer",
    getIntegrationCode: "Obtenir le Code d'Intégration",
    widgetUsage: "Utilisation :",
    widgetUsageVue: "Utilisation (App.vue ou composant parent) :",
    widgetUsageNext: "Utilisation (app.tsx ou page.tsx) :",
    widgetNuxtPluginComment1: "// plugins/feedback-widget.client.js",
    widgetNuxtPluginComment2: "// Ce plugin initialise automatiquement toutes les pages",
    widgetNuxtPluginComment3: "// Configuré avec tenantId : {tenantId}",
    widgetWpUrlComment: "// URL du Widget - toujours chargé depuis feedpanels.com",
    widgetOtherScriptComment: "<!-- Charger le script du Widget -->",
    // Installation instructions by framework
    reactInstall1: "Copiez le code du composant ci-dessus",
    reactInstall2:
      "Ajoutez le composant à un emplacement approprié dans votre projet (ex: App.js ou composant Layout)",
    reactInstall3: "Importez et rendez le composant :",
    reactInstall4:
      "Enregistrez les modifications et actualisez votre application",
    reactInstall5:
      "Vérifiez que le bouton du widget apparaît lorsque le composant est rendu",
    vueInstall1: "Copiez le code du composant ci-dessus",
    vueInstall2: "Ajoutez le composant au dossier components dans votre projet",
    vueInstall3:
      "Importez et utilisez-le sur la page où vous souhaitez l'utiliser",
    vueInstall4:
      "Enregistrez les modifications et actualisez votre application",
    vueInstall5:
      "Vérifiez que le bouton du widget apparaît lorsque le composant est monté",
    nuxtInstall1: "Copiez le code du plugin ci-dessus",
    nuxtInstall2: "Enregistrez le code dans",
    nuxtInstall3: "fichier",
    nuxtInstall4: "Nuxt chargera automatiquement le plugin",
    nuxtInstall5: "Redémarrez votre application",
    nuxtInstall6:
      "Vérifiez que le bouton du widget apparaît lorsque la page se charge",
    nextInstall1: "Copiez le code du composant ci-dessus",
    nextInstall2: "Enregistrez le composant dans",
    nextInstall3: "fichier",
    nextInstall4:
      "Importez le composant dans votre fichier de layout ou de page :",
    nextInstall5:
      "Enregistrez les modifications et actualisez votre application",
    nextInstall6:
      "Vérifiez que le bouton du widget apparaît lorsque la page est rendue",
    wordpressInstall1: "Copiez le code PHP ci-dessus",
    wordpressInstall2: "Connectez-vous au panneau d'administration WordPress",
    wordpressInstall3:
      "Allez dans Apparence → Éditeur de thème → Ouvrez le fichier functions.php",
    wordpressInstall4: "Ajoutez le code à la fin du fichier functions.php",
    wordpressInstall5: "Enregistrez le fichier",
    wordpressInstall6:
      "Vérifiez que le bouton du widget apparaît lorsque vous actualisez la page",
    wordpressCodeComment: "WordPress: Ajouter à votre fichier functions.php",
    // Other framework guide
    otherUsage: "Utilisation sur n'importe quel site web",
    otherInstallation: "Installation",
    otherInstallationDescription:
      "Ajoutez cette balise de script unique pour activer toutes les fonctionnalités d'intégration FeedbackFlow:",
    otherFeature1: "Fonctionnalité 1: Outil de Commentaires",
    otherFeature1Description: "Collectez les commentaires de vos utilisateurs.",
    otherFeature1Details:
      "Le widget affiche automatiquement un bouton \"Demande de Fonctionnalité\" au centre inférieur de la page. Lorsque le bouton est cliqué, un modal de commentaires s'ouvre et les utilisateurs peuvent sélectionner l'un des types de commentaires suivants:",
    otherFeature1Item1: "- Demande de Fonctionnalité",
    otherFeature1Item2: "- Rapport de Bug",
    otherFeature1Item3: "- Autre",
    otherFeature1Item4: "",
    otherFeature2: "Fonctionnalité 2: Widget de Feuille de Route",
    otherFeature2Description:
      'Utilisez le bouton "Feuille de Route" dans le modal pour afficher votre feuille de route. Ce bouton ouvre votre page publique de feuille de route dans un nouvel onglet.',
    otherFeature3: "Fonctionnalité 3: Widget de Journal des Modifications",
    otherFeature3Description:
      'Utilisez le bouton "Journal des Modifications" dans le modal pour afficher les mises à jour récentes. Ce bouton ouvre votre page publique de journal des modifications dans un nouvel onglet.',
    otherCustomization: "Personnalisation",
    otherCustomizationDescription:
      "Vous pouvez personnaliser l'apparence du widget en modifiant les paramètres de la fonction init:",
    otherParam1: "- tenantId: Identifiant unique de votre projet",
    otherParam2:
      '- primaryColor: Couleur du bouton (au format hex, ex: "#0891b2")',
    otherParam3:
      '- backgroundColor: Couleur de fond du modal (au format hex, ex: "#ffffff")',
    otherParam4:
      '- buttonStyle: Style du bouton ("rounded-full", "rounded-lg", "rounded", "rounded-none")',
    otherParam5: '- fontSize: Taille de police (ex: "16px")',
    otherParam6: '- fontFamily: Famille de police (ex: "Inter, sans-serif")',
    otherParam7: '- theme: Thème ("light" ou "dark")',
    otherExample: "Exemple d'Utilisation",
    otherExampleBasic: "Configuration de base:",
    otherNote:
      "Note: Ajoutez le widget juste avant la balise </body> de votre site web. Le widget se chargera automatiquement et apparaîtra au centre inférieur de la page.",
    // Changelog
    changelogTitle: "Journal des Modifications",
    changelogDescription: "Tenez vos utilisateurs informés des mises à jour",
    viewPublicChangelog: "Voir le Journal des Modifications Public",
    newRelease: "Nouvelle Version",
    createChangelogEntry: "Créer une Entrée de Journal des Modifications",
    createChangelogDescription:
      "Documentez votre dernière version ou mise à jour",
    version: "Version",
    versionPlaceholder: "v2.1.0",
    title: "Titre",
    titlePlaceholder: "Intégration Slack et Améliorations de Performance",
    content: "Contenu",
    contentPlaceholder:
      "Nouvelles Fonctionnalités:\n- Intégration Slack\n- Mode sombre\n\nCorrections de Bugs:\n- Notifications par e-mail corrigées",
    publishChangelog: "Publier le Journal des Modifications",
    loadingChangelog: "Chargement du journal des modifications...",
    noChangelogEntries:
      "Aucune entrée dans le journal des modifications pour le moment",
    createFirstReleaseNote: "Créez votre première note de version",
    deleteChangelogEntry: "Supprimer l'Entrée du Journal des Modifications",
    deleteChangelogConfirm:
      "Êtes-vous sûr de vouloir supprimer cette entrée du journal des modifications?",
    deleteChangelogWarning:
      "Cette action ne peut pas être annulée et le journal des modifications sera supprimé à la fois du panneau d'administration et du portail public.",
    cancel: "Annuler",
    delete: "Supprimer",
    changelogCreated: "Journal des modifications créé",
    changelogCreateFailed: "Échec de la création du journal des modifications",
    changelogDeleted: "Journal des modifications supprimé avec succès",
    changelogDeleteFailed:
      "Échec de la suppression du journal des modifications",
    changelogLoadFailed: "Échec du chargement des journaux des modifications",
    pleaseSelectProject: "Veuillez d'abord sélectionner un projet",
    // Roadmap
    productRoadmap: "Feuille de Route Produit",
    roadmapDescription:
      "Planifiez et suivez les fonctionnalités de votre produit",
    newItem: "Nouvel Élément",
    createRoadmapItem: "Créer un Élément de Feuille de Route",
    createRoadmapDescription:
      "Ajoutez une nouvelle fonctionnalité ou initiative à votre feuille de route",
    roadmapTitle: "Titre",
    roadmapTitlePlaceholder: "Intégration Slack",
    roadmapDescriptionLabel: "Description",
    roadmapDescriptionPlaceholder:
      "Intégrer avec Slack pour les notifications...",
    quarter: "Trimestre",
    quarterPlaceholder: "Q2 2025",
    status: "Statut",
    createItem: "Créer l'Élément",
    loadingRoadmap: "Chargement de la feuille de route...",
    noRoadmapItems: "Aucun élément de feuille de route pour le moment",
    items: "éléments",
    fromFeedback: "Des Commentaires",
    votes: "votes",
    statusUpdated: "Statut mis à jour avec succès",
    statusUpdateFailed: "Échec de la mise à jour du statut",
    roadmapItemCreated: "Élément de feuille de route créé",
    roadmapItemCreateFailed: "Échec de la création de l'élément",
    roadmapLoadFailed: "Échec du chargement de la feuille de route",
    roadmapItemDeleted: "Élément de feuille de route supprimé. Il a également été retiré du panel public.",
    roadmapItemDeleteFailed: "Échec de la suppression de l'élément de la feuille de route",
    deleteRoadmapItem: "Supprimer l'élément de la feuille de route",
    deleteRoadmapItemConfirm: "Êtes-vous sûr de vouloir supprimer cet élément ? Il sera également retiré de la feuille de route publique.",
    roadmapItemFromFeedbackCannotDelete: "Cet élément provient d'un retour. Vous ne pouvez le supprimer que depuis le panel Retours.",
    // Roadmap Status Labels
    backlog: "En Attente",
    planned: "Planifié",
    inDevelopment: "En Développement",
    testing: "En Test",
    completed: "Terminé",
    // Feedback
    feedbackTitle: "Commentaires",
    feedbackDescription: "Gérez les commentaires et demandes des clients",
    loadingFeedback: "Chargement des commentaires...",
    noFeedbackYet: "Aucun commentaire pour le moment",
    noFeedbackDescription:
      "Les utilisateurs peuvent soumettre des commentaires via le portail public",
    loading: "Chargement...",
    submittedBy: "Soumis par",
    anonymous: "Anonyme",
    description: "Description",
    updateStatus: "Mettre à jour le Statut",
    upvotes: "Votes",
    views: "Vues",
    deleteFeedback: "Supprimer le Commentaire",
    deleteFeedbackConfirm: "Êtes-vous sûr de vouloir supprimer ce commentaire?",
    deleteFeedbackWarning:
      "Cette action ne peut pas être annulée. Le commentaire sera supprimé de:",
    adminPanel: "Panneau d'administration",
    publicPortal: "Portail public",
    roadmap: "Feuille de route",
    allRelatedVotes: "Tous les votes associés",
    cancel: "Annuler",
    delete: "Supprimer",
    feedbackDeleted: "Commentaire supprimé avec succès",
    feedbackDeleteFailed: "Échec de la suppression du commentaire",
    feedbackLoadFailed: "Échec du chargement des commentaires",
    voteFailed: "Échec du vote",
    statusUpdated: "Statut mis à jour",
    statusUpdateFailed: "Échec de la mise à jour du statut",
    // Feedback Type Labels
    feature: "Fonctionnalité",
    bug: "Bug",
    improvement: "Amélioration",
    other: "Autre",
    // Priority Labels
    low: "Faible",
    medium: "Moyen",
    high: "Élevé",
    urgent: "Urgent",
    // Comments
    comments: "Commentaires",
    comment: "Commentaire",
    writeComment: "Écrivez votre commentaire...",
    submitComment: "Envoyer le Commentaire",
    commentSubmitted: "Commentaire envoyé",
    commentSubmitFailed: "Échec de l'envoi du commentaire",
    commentRequired: "Le commentaire ne peut pas être vide",
    commentsLoadFailed: "Échec du chargement des commentaires",
    failedToLoadComments: "Échec du chargement des commentaires",
    failedToSubmitComment: "Échec de l'envoi du commentaire",
    noCommentsYet:
      "Aucun commentaire pour le moment. Soyez le premier à commenter!",
    reply: "Répondre",
    writeReply: "Écrivez votre réponse...",
    sendReply: "Envoyer la Réponse",
    replySubmitted: "Réponse envoyée",
    replySubmitFailed: "Échec de l'envoi de la réponse",
    cancelReply: "Annuler",
    internal: "Interne",
    public: "Public",
    projectSettings: "Paramètres du Projet",
    enableComments: "Activer les Commentaires",
    enableCommentsDescription:
      "Permettre aux utilisateurs de commenter les commentaires",
    commentsEnabled: "Commentaires activés",
    commentsDisabled: "Commentaires désactivés",
    settingsUpdateFailed: "Échec de la mise à jour des paramètres",
    unsavedChangesTitle: "Modifications Non Enregistrées",
    unsavedChangesMessage:
      "Vous avez des modifications non enregistrées dans vos paramètres de personnalisation. Si vous passez au code d'intégration, ces modifications seront perdues et le code sera différent de vos paramètres actuels.",
    continueAnyway: "Continuer Quand Même",
    // Dashboard
    welcomeBack: "Bienvenue de nouveau ! 👋",
    dashboardIntro: "Voici ce qui se passe avec vos commentaires :",
    totalFeedback: "Total des commentaires",
    allTime: "Depuis toujours",
    activeFeedback: "Commentaires actifs",
    inProgress: "En cours",
    thisMonth: "Ce mois-ci",
    newSubmissions: "Nouvelles soumissions",
    topFeedback: "Meilleurs commentaires",
    noFeedbackYet: "Aucun commentaire pour l'instant",
    yourProjects: "Vos projets",
    active: "Actif",
    created: "Créé",
    quickActions: "Actions rapides",
    viewAllFeedback: "Voir tous les commentaires",
    manageRoadmap: "Gérer la feuille de route",
    setupWidget: "Configurer le widget",
    publicPages: "Pages publiques",
    publicFeedback: "Commentaires publics",
    publicRoadmap: "Feuille de route publique",
    publicChangelog: "Journal des modifications public",
    selectProjectToViewPublicPages:
      "Sélectionnez un projet pour voir les pages publiques",
    ipAddress: "Adresse IP",
    daysRemaining: "Jours restants",
    status: "Statut",
    statsLoadFailed: "Échec du chargement des statistiques",
    welcomeToFeedbackFlow: "Bienvenue sur FeedbackFlow ! 🎉",
    firstProjectModalDescription:
      "Créez votre premier projet pour commencer. Un nom de projet vous aide à organiser vos commentaires.",
    moreProjectsHint: "💡 Vous pouvez ajouter plus de projets à tout moment",
    createProject: "Créer un projet",
    creatingProject: "Création en cours...",
    projectNamePlaceholder: "Ex: Mon application web",
    pleaseEnterProjectName: "Veuillez entrer le nom du projet",
    projectCreatedWelcome: "Projet créé ! Bienvenue sur FeedbackFlow !",
    howToIntegrateButton: "Comment intégrer?",
    integrationGuideTitle: "Guide d'Intégration",
    integrationPreStep: "Avant de commencer",
    integrationPreStepDesc: "Avant de commencer, veuillez créer votre projet et n'oubliez pas d'attribuer un nom de domaine au projet que vous avez créé. Si votre projet et votre domaine sont déjà créés, assurez-vous que le projet que vous souhaitez intégrer est sélectionné comme projet actif.",
    integrationStep1: "Accédez à l'onglet 'Intégration' depuis le menu du Tableau de bord",
    integrationStep1Desc: "Cliquez sur l'onglet 'Intégration' ou 'Widget' dans le menu de gauche pour accéder à la page d'intégration. Ici, vous pouvez personnaliser votre widget et obtenir le code d'intégration.",
    integrationStep2: "Personnalisez les paramètres de votre widget (couleur, position, style, etc.)",
    integrationStep2Desc: "Personnalisez l'apparence de votre widget pour qu'elle corresponde à votre marque. Vous pouvez modifier des paramètres tels que la couleur, le style du bouton, la famille de polices et la taille. Cliquez sur le bouton 'Enregistrer' pour enregistrer vos modifications.",
    integrationStep3: "Copiez le code d'intégration pour votre framework",
    integrationStep3Desc: "Accédez à l'onglet 'Code d'Intégration' et sélectionnez votre framework (React, Vue, Next.js, WordPress, etc.). Copiez le code préparé pour votre framework sélectionné.",
    integrationStep4: "Ajoutez le code à l'endroit approprié sur votre site Web",
    integrationStep4Desc: "Collez le code copié à l'endroit approprié sur votre site Web. Généralement, vous devez ajouter le composant widget à votre fichier de mise en page principal ou composant racine. Le code chargera automatiquement le widget.",
    integrationStep5: "Votre widget est maintenant prêt à être utilisé!",
    integrationStep5Desc: "Après avoir ajouté le code, actualisez votre site Web. Le bouton du widget apparaîtra en bas de votre page. Les utilisateurs peuvent cliquer sur ce bouton pour soumettre des commentaires.\n\nRemarque: Votre ID de Tenant a été automatiquement intégré dans le code d'intégration. Cet ID détermine le projet auquel les commentaires seront envoyés. Vous pouvez voir votre ID de Tenant dans le code d'intégration du widget.",
    previous: "Précédent",
    next: "Suivant",
    purchaseLicense: "Acheter la licence",
    // Public Portal
    publicPortal: "Portail Public",
    feedbackNav: "Commentaires",
    roadmapNav: "Feuille de Route",
    changelogNav: "Journal des Modifications",
    feedbackTitle: "💬 Commentaires",
    feedbackDescription: "Partagez vos commentaires et idées",
    submitFeedback: "Envoyer un Commentaire",
    submitYourFeedback: "Envoyez votre Commentaire",
    helpUsImprove:
      "Aidez-nous à nous améliorer en partageant vos idées et suggestions",
    feedbackType: "Type de Commentaire",
    featureRequest: "Demande de Fonctionnalité",
    bugReport: "Rapport de Bug",
    improvement: "Amélioration",
    other: "Autre",
    title: "Titre",
    briefDescription: "Brève description de votre commentaire",
    description: "Description",
    provideMoreDetails: "Fournissez plus de détails sur votre commentaire...",
    yourName: "Votre Nom",
    yourEmail: "Votre Email",
    feedbackSubmittedSuccess:
      "Commentaire envoyé avec succès! Il sera visible après révision.",
    projectNotFound: "Projet Non Trouvé",
    projectNotFoundDescription: "Le projet que vous recherchez n'existe pas",
    projectNotFoundText:
      "Le projet auquel vous essayez d'accéder n'existe pas ou n'a pas encore été configuré.",
    contactAdministrator:
      "Veuillez contacter l'administrateur, puis réessayez d'accéder à la page publique.",
    all: "Tous",
    backlog: "En Attente",
    planned: "Planifié",
    inDevelopment: "En Développement",
    testing: "Test",
    completed: "Terminé",
    new: "Nouveau",
    underReview: "En Révision",
    inProgress: "En Cours",
    mostVoted: "Les Plus Votés",
    newestFirst: "Plus Récent en Premier",
    oldestFirst: "Plus Ancien en Premier",
    noFeedbackYet: "Aucun commentaire pour le moment",
    beFirstToShare: "Soyez le premier à partager vos pensées!",
    views: "vues",
    by: "par",
    voteSaved: "Votre vote a été enregistré!",
    voteRemoved: "Vote supprimé",
    failedToVote: "Échec du vote. Veuillez réessayer.",
    failedToLoadFeedback: "Échec du chargement des commentaires",
    loading: "Chargement...",
    productRoadmap: "Feuille de Route Produit",
    seeWhatWeWorkingOn:
      "Découvrez ce sur quoi nous travaillons et ce qui vient ensuite",
    noRoadmapItemsYet: "Aucun élément de feuille de route pour le moment",
    items: "éléments",
    loadingRoadmap: "Chargement de la feuille de route...",
    failedToLoadRoadmap: "Échec du chargement de la feuille de route",
    changelog: "Journal des Modifications",
    stayUpdated: "Restez à jour avec nos dernières versions et améliorations",
    noReleasesYet: "Aucune version pour le moment",
    checkBackSoon: "Revenez bientôt pour les mises à jour",
    loadingChangelog: "Chargement du journal des modifications...",
    failedToLoadChangelog: "Échec du chargement du journal des modifications",
    boardNotFound: "Tableau Non Trouvé",
    boardNotFoundDescription: "Le tableau que vous recherchez n'existe pas",
    boardNotFoundText:
      "Le tableau auquel vous essayez d'accéder n'existe pas ou n'a pas encore été configuré.",
    contactAdminToSetup:
      "Veuillez contacter l'administrateur pour configurer un tableau, puis réessayez d'accéder à la page publique.",
    selectCategory: "Sélectionner une catégorie",
    category: "Catégorie",
    poweredBy: "Propulsé par",
    footerCopyright: `© ${new Date().getFullYear()} Créé par ZeuZ IT`,
    privacyPolicy: "Politique de Confidentialité",
    legalNotice: "Mentions Légales",
    // Inactive Project Modal
    inactiveProjectTitle: "⚠️ Projet Inactif",
    inactiveProjectMessage: "Ce projet n'est pas actif. Vous ne pouvez pas utiliser les intégrations ni initialiser le widget pour ce projet.",
    inactiveProjectExplanation: "Pour activer ce projet, allez à Gestion des Plans → Projets Actifs et activez-le.",
    activate: "Activer et Ouvrir",
    activatingProject: "Activation en cours...",
    goToPlanManagement: "Gérer Tous",
    cancel: "Annuler",
    maxActiveProjectsReached: "Nombre maximum de projets actifs atteint",
    activationFailed: "Impossible d'activer le projet",
    projectActivated: "Projet activé avec succès",
    projectDeactivated: "Projet désactivé avec succès",
    // Pending Plan Change Modal
    pendingDowngradeTitle: "Changement de Plan en Attente",
    pendingDowngradeMessage: "Votre passage au plan {plan} est prévu pour {date}. Veuillez attendre la fin du processus.",
    ok: "OK",
  },
};

export const SUPPORTED_LANGUAGES = ["en", "tr", "de", "es", "fr"];

// English is the canonical language of "/". Every other language is addressable
// as /?lang=xx, which is what the hreflang tags on the landing page point at —
// so a language variant has to be reachable by URL, not only by localStorage.
export const DEFAULT_LANGUAGE = "en";

const readLanguageFromUrl = () => {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("lang");
    return SUPPORTED_LANGUAGES.includes(fromUrl) ? fromUrl : null;
  } catch {
    return null;
  }
};

// Keep /?lang=xx in sync with the active language on the landing page only, so
// the URL a visitor copies renders the language they were actually reading.
// Other routes keep clean URLs. `replaceState` avoids a router navigation.
const syncUrlLanguage = (lang) => {
  try {
    if (window.location.pathname !== "/") return;
    const url = new URL(window.location.href);
    if (lang === DEFAULT_LANGUAGE) {
      url.searchParams.delete("lang");
    } else {
      url.searchParams.set("lang", lang);
    }
    window.history.replaceState({}, "", url.pathname + url.search + url.hash);
  } catch {
    /* history API unavailable — the language still applies, only the URL lags */
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Precedence: explicit ?lang= in the URL > saved choice > default.
    const fromUrl = readLanguageFromUrl();
    if (fromUrl) return fromUrl;
    const stored = localStorage.getItem("app_language");
    return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    // Try to load language from backend notification preferences
    const loadLanguageFromBackend = async () => {
      try {
        const token = localStorage.getItem("token");
        if (token) {
          const response = await api.get("/auth/notification-preferences");
          const backendLanguage = response.data.language || DEFAULT_LANGUAGE;
          // An explicit ?lang= in the URL is a deliberate request — don't let the
          // saved account preference overwrite it.
          if (readLanguageFromUrl()) return;
          if (backendLanguage !== language) {
            setLanguage(backendLanguage);
            localStorage.setItem("app_language", backendLanguage);
          }
        }
      } catch (error) {
        console.error("Failed to load language from backend:", error);
      }
    };

    loadLanguageFromBackend();
  }, []);

  useEffect(() => {
    localStorage.setItem("app_language", language);
  }, [language]);

  const updateLanguage = async (newLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem("app_language", newLanguage);
    syncUrlLanguage(newLanguage);
    // Also update in backend
    try {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await api.get("/auth/notification-preferences");
        const updatedPreferences = {
          ...response.data,
          language: newLanguage,
        };
        await api.put("/auth/notification-preferences", updatedPreferences);
      }
    } catch (error) {
      console.error("Failed to update language in backend:", error);
    }
  };

  const t = translations[language] || translations[DEFAULT_LANGUAGE];

  return (
    <LanguageContext.Provider
      value={{ language, setLanguage: updateLanguage, t }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
